<!-- Remarks:
    - 跳堂：
      -> Conditions:
        * lesson 要比咗錢
        * lesson要regular type
        * attendance status 要 pending
        * 如果用月票assign，不可跳堂
      -> Result:
        * 會將該堂調去下一個同course code，而又未paid嘅lesson（唔理有冇報到下一堂）。
        * 如果該堂已paid，會mark埋去下一堂`paid`。remove呢堂嘅`paid`。
        * 如果該堂有用package，會mark埋去下一堂`package_quote`。呢堂嘅`package_quote`照keep。
        * 如果該堂有用月票，會mark埋去下一堂`monthly_used`。會remove呢堂嘅`monthly_used`。
        * 呢堂嘅`student`照keep。
        * remove下一堂`exit`。呢堂add `exit`。
        * 唔會改到原本嘅order，但skip to 嘅個堂會出現係payment dashboard到比user揀入下一張order到（for record only）。
      -> Case 套票student（單一跳堂）
        -> check 有冇下一堂 -> 冇堂，問加唔加堂 -> 加，加一堂 -> skip_lesson
        -> check 有冇下一堂 -> 冇堂，問加唔加堂 -> 唔加 -> update_lesson student attendance to "skip"
        -> check 有冇下一堂 -> 有堂 -> skip_lesson
      -> Case normal student（單一跳堂）
        -> check 有冇下一堂 -> 冇堂 -> reject
        -> check 有冇下一堂 -> 有堂 -> skip_lesson
      -> Case 批量skip
        -> check 有冇下一堂 -> 冇堂 -> reject
      
    - 轉堂：揀一堂後，將未上果N堂都轉去依個course到 (start from this lesson date)，比咗錢嘅堂會mark paid落轉去嘅lesson到
      -> Conditions:
        * 如果該堂有訂單而又未付款，不可調堂 (防止將訂單變paid時，啲lesson唔對，搞到有bug)
        * 如果用月票assign，不可轉堂
      -> Result:
        * 將未上果N堂都轉去依個course到 (start from this lesson date)
        * 如果該堂已paid，會mark埋去下一堂`paid`。remove呢堂嘅`paid`。
        * 如果該堂有用package，會mark埋去下一堂`package_quote`。會remove呢堂嘅`package_quote`。
        * 如果該堂有用月票，會mark埋去下一堂`monthly_used`。會remove呢堂嘅`monthly_used`。
        * remove 呢堂嘅`student`
        * remove下一堂`exit`。呢堂add `exit`。
        * 唔會改到原本嘅order
    
    - 轉堂(單一課堂)：轉一堂
      -> Conditions:
        * 如果該堂有訂單而又未付款，不可調堂
        * 如果用月票assign，會check轉過去嘅lesson日期是否在月票範圍內。如不是，不可調堂
      -> Result:
        * 如果該堂已paid，會mark埋去下一堂`paid`。remove呢堂嘅`paid`。
        * 如果該堂有用package，會mark埋去下一堂`package_quote`。會remove呢堂嘅`package_quote`。
        * 如果該堂有用月票，會mark埋去下一堂`monthly_used`。會remove呢堂嘅`monthly_used`。
        * remove 呢堂嘅`student`
        * remove下一堂`exit`。呢堂add `exit`。
        * 會replace order原本嘅堂做新堂

    - 退課：成個course drop (start from this lesson date)
      -> Conditions:
        * 如果該堂有訂單而又未付款，不可退課
      -> Result:
        * remove `package_quote`,`monthly_used`,`student`
        * add `exit`。
        * `paid`照keep。
    
    - 退課（單一課堂）：退一堂
      -> Conditions:
        * 如果該堂有訂單而又未付款，不可退課
      -> Result:
        * remove `package_quote`,`monthly_used`,`student`, `attendance`
        * add `exit`。
        * `paid`照keep。

    - 回復轉堂動作：將學生轉返原本課堂
      -> 會update order lesson data

    - 新增學生(扣除套票)
      -> (繳付學費) 如果學生已在課堂，但未比錢，而又有package quota，可用quota完成paid
      -> (新增) 如果學生不在課堂，沒有package quota，加學生到此課堂，mark unpaid
      -> (新增) 如果學生不在課堂，有package quota，加學生到此課堂，mark paid

    - 調堂到此課堂：同 轉堂(單一課堂)

    - 新增其他課堂：如果用 lesson_count/end_date 嘅方法加堂，呢堂嘅學生(除咗用package assign)都會帶咗去新嘅堂到。會mark unpaid。
-->
<template>
  <v-container fluid>
    <PageHeaderSlot :title="pageTitle" showBackButton>
      <template slot="bottom-right-slot">
        <FormButton
          v-if="canEdit"
          class="ml-2"
          outlined
          color="error"
          text="delete"
          @click="handleDeleteThisLesson()"
        />
        <FormButton v-if="canEdit || canTakeAttendance || canTutorEdit" class="ml-2" @click="save()" />
      </template>
    </PageHeaderSlot>

    <v-row class="ma-0 align-stretch">
      <v-col class="pa-0 mb-4" cols="12" md="4">
        <v-card class="course-info">
          <div class="d-flex justify-space-between align-center pr-5">
            <v-card-title>{{ $t('lessonInfo') }}</v-card-title>
            <v-btn
              v-if="canEditClassDetail"
              depressed
              text
              color="primary"
              :ripple="false"
              class="pa-0"
              @click.prevent="handleEditClassSetting('edit')"
            >
              <v-icon class="fi fi-rr-pencil mr-1" size="18"></v-icon>
              {{ $t('editLesson') }}
            </v-btn>
          </div>

          <v-card-text class="pb-6 px-0">
            <div class="course-code text-right pa-4 mb-6">
              {{
                staticLessonInfo.course_code && gDisableEmptyCode
                  ? `${$t('courseCode')} : ${staticLessonInfo.course_code}`
                  : ''
              }}
            </div>
            <v-form ref="classInfoForm" @submit.prevent>
              <v-row class="ma-0">
                <v-col class="py-0" cols="12">
                  <FormDatePicker
                    label="date"
                    :dateValue.sync="formData.date"
                    required
                    disabledActionButtons
                    dispatchUpdateOnChange
                    disableClear
                    :readonly="!canEdit"
                    :holidayData="holidayList"
                  />
                </v-col>
                <v-col class="py-0" cols="12">
                  <FormRangeTimePicker
                    label="time"
                    :startTimeValue.sync="formData.start_time"
                    :endTimeValue.sync="formData.end_time"
                    required
                    dispatchUpdateOnChange
                    :readonly="!canEdit"
                  />
                </v-col>
                <v-col class="py-0" cols="12">
                  <FormUploader
                    uploadText="uploadNote"
                    fileInputKey="upload_lectures"
                    :files.sync="formData.attachment_list"
                    :acceptFormat="['image', 'pdf']"
                    dispatchUpdateOnChange
                    :readonly="!canEdit && !canTutorEdit"
                  />
                </v-col>
                <v-col class="py-0 mt-6" cols="12" v-if="isAppMode(['DEV', 'T04'])">
                  <FormUploader
                    fileInputKey="upload_lectures_vimeo"
                    :files.sync="formData.vimeo_attachment_list"
                    :acceptFormat="['vimeo']"
                    dispatchUpdateOnChange
                    :readonly="!canEdit && !canTutorEdit"
                    single
                  />
                </v-col>
                <v-col class="py-0 mt-6" cols="12" v-if="!isAppMode(['T01', 'T47'])">
                  <FormTextarea
                    label="remark"
                    :fieldValue.sync="formData.remark"
                    dispatchUpdateOnChange
                    :readonly="!canEdit && !canTutorEdit"
                    noResize
                    :rows="isAppMode(['T46']) ? 3 : 2"
                  />
                </v-col>
                <v-col class="py-0 mt-6" cols="12" v-if="isAppMode(['T47'])">
                  <FormTextarea
                    label="remark"
                    :fieldValue.sync="formData.remark"
                    dispatchUpdateOnChange
                    :readonly="!canEdit"
                    noResize
                    :rows="isAppMode(['T46']) ? 3 : 2"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-0 pl-md-4 mb-4" cols="12" md="8">
        <Datatable
          :isLoading="tableLoading"
          :tableData="studentTableData"
          :tableHeaders="studentTableHeaders"
          disablePagination
          tableName="student"
          tableEmptyText="noStudent"
          enableExport
          @export-clicked="exportAttendance()"
          :exporting="exportLoading"
          noWrapToolbar
        >
          <template slot="append-toolbar-left">
            <FormButton v-if="canAddStudent" text="addStudent" class="ml-1 my-2" @click="handleAddStudentAction()" />
            <FormButton v-if="isAppMode(['UAT','T61','T79'])" text="selectAllAttend" class="ml-1 my-2" @click="selectAllAttend()" />
          </template>
          <template v-slot:[`item.class_student_name`]="{ item }">
            <div class="d-flex align-center">
              <div v-if="!isAppMode(['T02'])" class="gender-dot gender-m"></div>
              <div
                style="white-space: nowrap;"
                :class="{
                  'red--text': item.unpaid,
                  'accent--text': !item.unpaid && item.last_lesson_id === id,
                }"
              >
                {{ item.class_student_name }}
              </div>
              <v-btn
                v-if="enableViewStudent(item.id)"
                icon
                depressed
                x-small
                :to="{ name: 'StudentDetails', params: { id: item.id } }"
                :disabled="item.removed_student"
              >
                <v-icon class="fi fi-rr-eye" size="12" color="primary"></v-icon>
              </v-btn>
              <v-btn
                v-if="isAppMode(['T37']) && item.last_lesson_id === id && !item.removed_student"
                icon
                depressed
                x-small
                @click.prevent="handleSendPackageLastRemind(item.id)"
              >
                <v-icon size="15" color="whatsapp">{{ icon.mdiWhatsapp }}</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.attend_status`]="{ item }">
            <v-radio-group
              v-model="item.attend_status"
              row
              hide-details
              class="ma-0"
              :class="{ 'pb-4': item.attend_status === 'attend' && item.attend_time }"
              dense
              @change="$store.dispatch('setDataIsUpdated', true)"
            >
              <v-radio
                v-if="item.attend_status === 'skip'"
                class="mr-2"
                :label="$t('attendanceStatus.skip')"
                value="skip"
              ></v-radio>
              <template v-else>
                <v-radio class="mr-2 my-2" :label="$t('attendanceStatus.pending')" value="pending"></v-radio>
                <v-radio class="mr-2 my-2" value="attend">
                  <template slot="label">
                    <div style="position: relative;">
                      {{ $t('attendanceStatus.attend') }}
                      <small
                        v-if="item.attend_status === 'attend' && item.attend_time"
                        class="d-block"
                        style="position: absolute; white-space: nowrap;"
                      >
                        {{ $t('attendTime', { time: item.attend_time }) }}
                      </small>
                    </div>
                  </template>
                </v-radio>
                <v-radio class="mr-2 my-2" :label="$t('attendanceStatus.absent')" value="absent"></v-radio>
                <v-radio
                  v-if="gEnableLessonLeaveStatus"
                  class="mr-2 my-2"
                  :label="$t('attendanceStatus.await')"
                  value="await"
                ></v-radio>
                <!-- 跳堂 -->
                <v-radio
                  v-if="enableMultipleSkip && item.can_skip && !item.quit_student && canSkip"
                  class="mr-2 my-2"
                  :label="$t('attendanceStatus.skip')"
                  value="new_skip"
                ></v-radio>
              </template>
            </v-radio-group>
          </template>
          <template v-slot:[`item.actionTransfer`]="{ item }">
            <TableDropdown
              :show="
                !!(
                  (item.attend_status !== 'skip' ||
                    (canSkip && enableUndoSkip && !item.quit_student && item.can_undo_skip)) &&
                  (canEdit ||
                    canTutorEdit ||
                    $validate.DataValid(item.feedback) ||
                    (!gDisableLessonProgress && isAppMode(['T49']) && userType === 'tutor'))
                )
              "
            >
              <template slot="list">
                <template v-if="item.attend_status !== 'skip'">
                  <!-- 跳堂 -->
                  <v-list-item
                    v-if="canSkip && item.can_skip && !item.quit_student"
                    @click.prevent="skipLesson(item.id)"
                    :disabled="$store.getters.isLoading"
                  >
                    <v-list-item-title>{{ $t('skipLesson') }}</v-list-item-title>
                  </v-list-item>
                  <!-- 轉堂 -->
                  <v-list-item
                    v-if="canEdit && !item.quit_student && item.can_switch_course"
                    @click.prevent="openChangeLesson('all', item.id)"
                    :disabled="$store.getters.isLoading"
                  >
                    <v-list-item-title>{{ $t('switchLesson') }}</v-list-item-title>
                  </v-list-item>
                  <!-- 轉堂(單一課堂) -->
                  <v-list-item
                    v-if="canEdit && !item.quit_student"
                    @click.prevent="openChangeLesson('single', item.id)"
                    :disabled="$store.getters.isLoading"
                  >
                    <v-list-item-title>{{ $t('switchSingleLesson') }}</v-list-item-title>
                  </v-list-item>
                  <!-- 退課 -->
                  <v-list-item v-if="canEdit" @click.prevent="dropCourse(item.id)" :disabled="$store.getters.isLoading">
                    <v-list-item-title>{{ $t('dropCourse') }}</v-list-item-title>
                  </v-list-item>
                  <!-- 退課（單一課堂） -->
                  <v-list-item v-if="canEdit" @click.prevent="dropLesson(item.id)" :disabled="$store.getters.isLoading">
                    <v-list-item-title>{{ $t('dropLesson') }}</v-list-item-title>
                  </v-list-item>
                  <!-- 新增課堂進度 -->
                  <v-list-item
                    v-if="!gDisableLessonProgress && (canTutorEdit || (isAppMode(['T49']) && userType === 'tutor'))"
                    @click.prevent="handleAddProgress(item.id)"
                    :disabled="$store.getters.isLoading"
                  >
                    <v-list-item-title>{{ $t('addLessonProgress') }}</v-list-item-title>
                  </v-list-item>
                  <!-- 課堂進度 -->
                  <v-list-item
                    v-if="!gDisableLessonProgress && (canTutorEdit || (isAppMode(['T49']) && userType === 'tutor'))"
                    @click.prevent="openViewProgress(item.id)"
                    :disabled="$store.getters.isLoading"
                  >
                    <v-list-item-title>{{ $t('lessonProgress') }}</v-list-item-title>
                  </v-list-item>
                  <template v-if="isAppMode(['DEV', 'T46', 'T61']) && canTutorEdit">
                    <!-- 新增請假備註 -->
                    <v-list-item @click.prevent="handleAddLeaveRemark(item.id)" :disabled="$store.getters.isLoading">
                      <v-list-item-title>{{ $t('addLeaveRemark') }}</v-list-item-title>
                    </v-list-item>
                    <!-- 請假備註 -->
                    <v-list-item @click.prevent="openLeaveRemark(item.id)" :disabled="$store.getters.isLoading">
                      <v-list-item-title>{{ $t('leaveRemark') }}</v-list-item-title>
                    </v-list-item>
                  </template>
                  <!-- 回復轉堂動作 -->
                  <v-list-item
                    v-if="canEdit && enableUndoSwitch && !item.quit_student && item.can_undo_switch"
                    @click.prevent="undoSwitch(item.id)"
                    :disabled="$store.getters.isLoading"
                  >
                    <v-list-item-title>{{ $t('undoSwitchLesson') }}</v-list-item-title>
                  </v-list-item>
                </template>
                <!-- 回復跳堂動作 -->
                <v-list-item
                  v-if="canSkip && enableUndoSkip && !item.quit_student && item.can_undo_skip"
                  @click.prevent="undoSkip(item.id)"
                  :disabled="$store.getters.isLoading"
                >
                  <v-list-item-title>{{ $t('undoSkipLesson') }}</v-list-item-title>
                </v-list-item>
                <!-- 學員回饋 -->
                <v-list-item v-if="$validate.DataValid(item.feedback)" @click.prevent="openFeedback(item.feedback)">
                  <v-list-item-title>{{ $t('studentFeedback') }}</v-list-item-title>
                </v-list-item>
              </template>
            </TableDropdown>
          </template>
        </Datatable>

        <p class="text-caption mt-2 mb-0 colorBlack--text">{{ $t('studentNoPayTuition') }}</p>
        <p class="text-caption colorBlack--text">{{ $t('studentLastLesson') }}</p>
      </v-col>
    </v-row>

    <!-- 導師 -->
    <Datatable
      v-if="!isAppMode(['T01', 'T16'])"
      class="mb-4"
      tableName="tutor"
      :isLoading="tutorTableLoading"
      :tableData="tutorTableData"
      :tableHeaders="tutorTableHeaders"
      disablePagination
      @edit-clicked="handleEditTutorSalary($event)"
    >
      <template v-slot:[`item.salary_method`]="{ item }">
        <span v-if="item.salary_method === 'percentage'">
          {{ $t(`salaryMethodOptions.${item.salary_method}`) }}: {{ item.percentage }}%
        </span>
        <span v-else-if="item.salary_method === 'hour'">
          {{ $t(`salaryMethodOptions.${item.salary_method}`) }}: HK${{ item.salary_per_hour }}
        </span>
        <span v-else-if="item.salary_method === 'level'">
          {{ $t(`salaryMethodOptions.${item.salary_method}`) }}: {{ gfSalaryLevelName(item.salary_level) }}
          {{
            item.salary_level && $validate.DataValid(item.salary_level_price) ? ` (HK$${item.salary_level_price})` : ''
          }}
        </span>
      </template>
      <template v-slot:[`item.attend_status`]="{ item }">
        <div class="d-flex align-center">
          <v-radio-group
            v-model="item.attend_status"
            row
            hide-details
            class="ma-0"
            dense
            @change="$store.dispatch('setDataIsUpdated', true)"
            :readonly="$validate.DataValid(item.attend_confirm_time) || !canTakeAttendance"
          >
            <v-radio class="mr-2 my-2" :label="$t('attendanceStatus.pendingTutor')" value="pending"></v-radio>
            <v-radio class="mr-2 my-2" value="attend">
              <template slot="label">
                <div style="position: relative;">
                  {{ $t('attendanceStatus.attend') }}
                  <small
                    v-if="item.attend_status === 'attend' && item.attend_time"
                    class="d-block"
                    style="position: absolute; white-space: nowrap;"
                  >
                    {{ $t('attendTime', { time: item.attend_time }) }}
                  </small>
                </div>
              </template>
            </v-radio>
            <v-radio class="mr-2 my-2" :label="$t('attendanceStatus.absent')" value="absent"></v-radio>
          </v-radio-group>
          <FormButton
            v-if="
              canConfirmTutorAttendance &&
                item.init_attend_status !== 'pending' &&
                !$validate.DataValid(item.attend_confirm_time)
            "
            small
            text="confirmAttend"
            class="ml-2"
            @click="confirmAttendance(item.id)"
          />
        </div>
      </template>
    </Datatable>

    <!-- 課程其他課堂 -->
    <Datatable
      tableName="otherLesson"
      tableEmptyText="noOtherLesson"
      :enableSelectAction="canEdit"
      :enableSelectToggle="canEdit"
      :isLoading="otherLessonTableLoading"
      :tableData="otherLessonTableData"
      :tableHeaders="otherClassTableHeaders"
      disablePagination
      @select-action-changes="handleSelectActionChange($event)"
      :selectedTableRow.sync="otherLessonSelectedRow"
      @edit-clicked="handleEditOtherLesson($event)"
      @delete-clicked="handDeleteLesson($event)"
      actionViewRouteLink="ClassDetails"
    >
      <template v-slot:[`item.actionViewCustom`]="{ item }">
        <v-btn
          v-if="item.canView"
          depressed
          text
          color="primary"
          :ripple="false"
          class="pa-0"
          small
          :to="{ name: 'ClassDetails', params: { id: item.id } }"
        >
          <v-icon class="fi fi-rr-eye mr-1" size="18"></v-icon>
          {{ $t('table.view') }}
        </v-btn>
      </template>
    </Datatable>

    <div class="mt-2 text-subtitle-1">{{ $t('lessonTotal', { count: otherLessonTableData.length + 1 }) }}</div>
    <v-row class="mt-4" v-if="canEdit && staticLessonInfo.lesson_type === 'regular'">
      <v-col cols="12">
        <FormButton text="addOtherLesson" @click="handleAddOtherLesson()" :disabled="otherLessonTableLoading" />
      </v-col>
    </v-row>

    <!-- Log Record -->
    <LogTable
      v-if="canViewLog"
      ref="logTableRef"
      class="mt-6"
      :loading="logLoading"
      :tableData="logTableData"
      :total="logTableTotal"
      @options-update="getLogData()"
    />

    <!-- Modal: 修改課堂 / 新增一個單一課堂 -->
    <FormDialog
      ref="editClassFormDialog"
      formRef="editClassForm"
      :title="isAddNewSingle() ? 'addSingleLesson' : 'editLesson'"
      :maxWidth="1100"
    >
      <v-row class="ma-0">
        <v-col cols="12" sm="6" md="4" lg="3">
          <FormSelect
            label="optionCourse"
            placeholder="optionCourse"
            :fieldValue.sync="classData.course_id"
            :options="courseOptions"
            required
            :isLoading="courseOptionLoading"
            @changed="onCourseChanged()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" v-if="isAddNewSingle() && gDisableEmptyCode">
          <FormInput label="courseCode" placeholder="courseCode" :fieldValue.sync="classData.course_code" required />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <FormInput label="courseName" placeholder="courseName" :fieldValue.sync="classData.course_name" required />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <FormInput
            type="number"
            label="price"
            placeholder="price"
            :fieldValue.sync="classData.price"
            prefix="HK$"
            suffix="perLesson"
            required
            isStrictFloat
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <FormSelect
            v-if="isAppMode(['T01', 'T16'])"
            label="tutor"
            placeholder="selectTutor"
            :fieldValue.sync="classData.tutor_id"
            :options="tutorOptions"
            :required="!isAppMode(['T02'])"
            @changed="onClassTutorChanged(false)"
            :isLoading="tutorOptionsLoading"
          />
          <FormSelect
            v-else
            label="tutor"
            placeholder="selectTutor"
            :fieldValue.sync="classData.tutor_id_list"
            :options="tutorOptions"
            :required="!isAppMode(['T02'])"
            isMultiple
            @changed="onClassTutorChanged()"
            :isLoading="tutorOptionsLoading"
          />
        </v-col>
        <template v-if="isAppMode(['T16'])">
          <v-col cols="12" sm="6" md="4" lg="3">
            <FormSelect
              label="salaryMethodType"
              placeholder="selectSalaryMethod"
              :fieldValue.sync="classData.t16_salary_type"
              :options="$salaryTypeOptions"
              required
              @changed="onSalaryTypeChanged()"
            />
          </v-col>
          <template v-if="classData.t16_salary_type === 'percentage'">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="salaryMethod"
                placeholder="selectSalaryMethod"
                :fieldValue.sync="classData.salary_method"
                :options="$salaryMethodOptions"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="salary"
                placeholder="salary"
                :fieldValue.sync="classData.t16_salary"
                prefix="HK$"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="salaryMethodOptions.percentage"
                placeholder="salaryMethodOptions.percentage"
                :fieldValue.sync="classData.t16_salary_percentage"
                suffix="%"
                required
              />
            </v-col>
          </template>
          <v-col cols="12" sm="6" md="4" lg="3" v-else-if="classData.t16_salary_type === 'hour'">
            <FormInput
              type="number"
              label="hourlyWage"
              :fieldValue.sync="classData.t16_salary_per_hour"
              prefix="HK$"
              suffix="perHour"
              required
            />
          </v-col>
        </template>

        <v-col cols="12" sm="6" md="4" lg="3">
          <FormSelect
            label="classroom"
            placeholder="selectClassroom"
            :fieldValue.sync="classData.classroom_id"
            :options="classroomOptions"
            :required="!isAppMode(['T16'])"
            :enableClear="isAppMode(['T16'])"
            :isLoading="classroomLoading"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <CourseColorPicker
            label="timetableColor"
            placeholder="selectTimetableColor"
            :fieldValue.sync="classData.color"
            required
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T01'])">
          <FormSelect
            label="salaryMethod"
            placeholder="selectSalaryMethod"
            :fieldValue.sync="classData.salary_method"
            :options="$salaryMethodOptions"
            required
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <FormSelect
            label="studentUpperLimit"
            placeholder="selectStudentUpperLimit"
            :fieldValue.sync="classData.max_student"
            :options="maxStudentOptions"
            required
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T04'])">
          <FormSelect
            label="lessonSchoolType"
            placeholder="lessonSchoolType"
            :fieldValue.sync="classData.school_type"
            :options="schoolTypeOptions"
            required
          />
        </v-col>
        <template v-if="!gDisableCourseToOnline">
          <v-col cols="12" sm="6" md="4" lg="3">
            <FormSelect
              label="showLessonInOnline"
              placeholder="showLessonInOnline"
              :fieldValue.sync="classData.show_website"
              :options="displayOnlineOptions"
              required
            />
          </v-col>
          <template v-if="classData.show_website">
            <v-col cols="12" sm="6" md="4" lg="3">
              <div style="height: 25px;" class="d-none d-sm-block"></div>
              <FormUploader
                uploadText="uploadThumbnail"
                fileInputKey="upload_thumbnail"
                :files.sync="classData.thumbnail_image_list"
                single
              />
            </v-col>
            <v-col cols="12">
              <QuillEditor :html.sync="classData.course_description" editorID="description" label="courseDescription" />
            </v-col>
          </template>
        </template>
        <template v-if="isAddNewSingle()">
          <v-col cols="12" sm="6" md="4" lg="3">
            <FormDatePicker
              label="singleLessonDate"
              :dateValue.sync="classData.date"
              required
              :minDate="startDateMin"
              disabledActionButtons
              :customRules="[v => checkLessonDateValid(classData.date)]"
              :holidayData="holidayList"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <FormRangeTimePicker
              label="time"
              :startTimeValue.sync="classData.start_time"
              :endTimeValue.sync="classData.end_time"
              required
              dispatchUpdateOnChange
              :readonly="!canEdit"
            />
          </v-col>
        </template>
      </v-row>
    </FormDialog>

    <!-- Modal: 轉堂/轉堂(單一課堂) -->
    <DialogLayout
      ref="changeLessonDialog"
      :title="changeLessonFilter.type === 'single' ? 'switchSingleLesson' : 'switchLesson'"
      :enableConfirm="false"
      cardContentClass="pa-0"
      eager
      :maxWidth="1000"
    >
      <div class="pa-4">
        <v-row class="ma-0 my-4">
          <v-col cols="12" sm="6">
            <FormSelect
              label="searchCourse"
              placeholder="selectCourseName"
              :fieldValue.sync="changeLessonFilter.keyword"
              :options="courseNameOptions"
              hideDetails
              :readonly="isSearching"
              :isLoading="courseNameSearching"
              @changed="onChangeLessonFilterChange()"
              enableClear
            />
          </v-col>

          <v-col cols="12" sm="6" v-if="changeLessonFilter.type === 'all'">
            <FormDatePicker
              label="lessonDate"
              placeholder="selectLessonDate"
              :dateValue.sync="changeLessonFilter.dateRange"
              isDateRange
              @changed="onChangeLessonFilterChange()"
              hideDetails
              :disabled="changeLessonFilter.mode === 'calendar' || changeLessonFilter.mode === 'timetable'"
              :holidayData="holidayList"
              :readonly="isSearching"
            />
          </v-col>
          <v-col cols="12" sm="6" v-else-if="changeLessonFilter.type === 'single'">
            <FormDatePicker
              label="lessonDate"
              placeholder="selectLessonDate"
              :dateValue.sync="changeLessonFilter.date"
              @changed="onChangeLessonFilterChange()"
              hideDetails
              :holidayData="holidayList"
              :readonly="isSearching"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <FormSelect
              label="tutor"
              placeholder="selectTutor"
              :fieldValue.sync="changeLessonFilter.tutor"
              :options="changeLessonTutorOptions"
              hideDetails
              :readonly="isSearching"
              @changed="onChangeLessonFilterChange()"
              enableClear
            />
          </v-col>

          <v-col cols="12" sm="6" v-if="!disableCourseGrade">
            <FormSelect
              label="grade"
              placeholder="selectGrade"
              :fieldValue.sync="changeLessonFilter.grade"
              :options="gradeOptions"
              hideDetails
              :readonly="isSearching"
              @changed="onChangeLessonFilterChange()"
              enableClear
            />
          </v-col>
        </v-row>
      </div>

      <div class="d-flex align-center px-6 text-subtitle-2">
        {{ $t('viewMode') }}:
        <v-btn
          class="py-1 px-2 ml-4 mr-2 text-subtitle-2"
          small
          :outlined="changeLessonFilter.mode === 'calendar'"
          :text="changeLessonFilter.mode !== 'calendar'"
          :color="changeLessonFilter.mode === 'calendar' ? 'primary' : 'colorGrey'"
          :disabled="isSearching"
          @click.prevent="onChangeLessonModeChanged('calendar')"
        >
          <v-icon size="15" class="mr-2 fi fi-rr-calendar"></v-icon>
          {{ $t('calendarMode') }}
        </v-btn>
        <v-btn
          class="py-1 px-2 mx-2 text-subtitle-2"
          small
          :outlined="changeLessonFilter.mode === 'timetable'"
          :text="changeLessonFilter.mode !== 'timetable'"
          :color="changeLessonFilter.mode === 'timetable' ? 'primary' : 'colorGrey'"
          :disabled="isSearching"
          @click.prevent="onChangeLessonModeChanged('timetable')"
        >
          <v-icon size="18" class="mr-2">{{ icon.mdiTimetable }}</v-icon>
          {{ $t('timetableMode') }}
        </v-btn>
        <v-btn
          class="py-1 px-2 mx-2 text-subtitle-2"
          small
          :outlined="changeLessonFilter.mode === 'list'"
          :text="changeLessonFilter.mode !== 'list'"
          :color="changeLessonFilter.mode === 'list' ? 'primary' : 'colorGrey'"
          :disabled="isSearching"
          @click.prevent="onChangeLessonModeChanged('list')"
        >
          <v-icon size="15" class="mr-2 fi fi-rr-angle-square-left"></v-icon>
          {{ $t('listMode') }}
        </v-btn>
      </div>

      <div class="px-6" v-show="changeLessonFilter.mode === 'calendar'">
        <p class="text-subtitle-2 font-weight-regular my-4">{{ $t('selectDateThenSelectLesson') }}</p>
        <v-btn
          v-if="$validate.DataValid(changeLessonFilter.date)"
          text
          plain
          color="colorBlack"
          class="pa-0"
          min-width="0"
          :ripple="false"
          depressed
          @click.prevent="backToCalendar()"
        >
          <v-icon size="15" class="mr-2 fi fi-rr-angle-square-left"></v-icon>
          {{ $t('backToCalendar') }}
        </v-btn>

        <v-progress-linear
          v-if="isSearching && !$validate.DataValid(changeLessonFilter.date)"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <v-date-picker
          v-show="!$validate.DataValid(changeLessonFilter.date)"
          v-model="changeLessonFilter.date"
          :picker-date.sync="datePickerDisplay"
          :first-day-of-week="0"
          full-width
          show-current
          no-title
          :locale="locale"
          :weekday-format="formatCalendarWeekday"
          :day-format="$formatter.dayFormat"
          :allowed-dates="checkDateCanSelect"
          :disabled="isSearching"
          @change="onChangeLessonFilterChange()"
        />

        <template v-if="changeLessonFilter.mode === 'calendar' && !$validate.DataValid(changeLessonFilter.date)">
          <div class="color-brick-row px-6 my-2 mt-4 text-caption">
            <div class="color-brick mr-2" style="background-color: #E3F0FF;"></div>
            {{ $t('dateHasLesson') }}
          </div>
          <div class="color-brick-row px-6 my-2 text-caption">
            <div class="color-brick mr-2" style="background-color: #1664C1;"></div>
            {{ $t('today') }}
          </div>
        </template>
      </div>

      <Datatable
        v-if="
          changeLessonFilter.mode === 'list' ||
            (changeLessonFilter.mode === 'calendar' && $validate.DataValid(changeLessonFilter.date))
        "
        :isLoading="isSearching"
        :tableData="searchTableData"
        :tableHeaders="changeLessonHeaders"
        :itemTotal="searchTableTotal"
        :page.sync="searchTableOptions.tablePage"
        :pageLimit.sync="searchTableOptions.tableLimit"
        :pageLimitOptions="searchTableOptions.limitOptions"
        @options-update="searchLesson()"
        tableEmptyText="calendar.noLesson"
      >
        <template v-slot:[`item.actionSelectChangeLesson`]="{ item }">
          <div class="colorGrey--text pointer-none" v-if="item.applied === true">
            {{ $t('lessonStatus.applied') }}
          </div>
          <div class="colorGrey--text pointer-none" v-else-if="item.same === true">{{ $t('lessonStatus.same') }}</div>
          <v-btn
            v-else
            :loading="$store.getters.isLoading"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleChangeLesson(item.id)"
            >{{ $t('switchLesson') }}</v-btn
          >
        </template>
      </Datatable>

      <div v-if="changeLessonFilter.mode === 'timetable'" class="timetableMode-view mt-4">
        <v-toolbar flat class="calendar-header flex-md-column" height="30"></v-toolbar>
        <v-calendar
          type="month"
          :locale="locale"
          :show-month-on-first="false"
          :weekday-format="_displayCalendarWeekday"
          :day-format="_displayCalendarDay"
        />
        <v-btn
          class="btn-timetableMode-open"
          x-large
          outlined
          color="colorWhite"
          @click.prevent="onChangeLessonModeChanged('timetable', true)"
        >
          <v-icon size="18" class="mr-2">{{ icon.mdiOpenInNew }}</v-icon>
          {{ $t('openTimetable') }}
        </v-btn>
      </div>

      <template slot="action">
        <FormButton
          v-if="changeLessonFilter.type === 'single' && canEditClassDetail"
          text="addSingleLesson"
          @click="handleEditClassSetting('new')"
        />
      </template>
    </DialogLayout>

    <!-- Modal: 課程表 -->
    <DialogLayout ref="changeLessonTimetable" title="timetableMode" eager :maxWidth="1500" hideAction>
      <v-toolbar flat class="custom-table-toolbar" height="auto">
        <v-toolbar-items class="toolbar-full-items flex-grow-1">
          <FormSelect
            placeholder="selectCourseName"
            :fieldValue.sync="changeLessonFilter.keyword"
            :options="courseNameOptions"
            hideDetails
            :readonly="isSearching"
            :isLoading="courseNameSearching"
            @changed="onChangeLessonFilterChange()"
            enableClear
            class="mr-3 mb-3"
          />
          <FormDatePicker
            placeholder="selectLessonDate"
            :dateValue.sync="changeLessonFilter.date"
            @changed="onTimetableDateChange()"
            hideDetails
            class="mr-3 mb-3"
          />
          <FormSelect
            placeholder="selectTutor"
            :fieldValue.sync="changeLessonFilter.tutor"
            :options="changeLessonTutorOptions"
            hideDetails
            :readonly="isSearching"
            @changed="onChangeLessonFilterChange()"
            class="mr-3 mb-3"
            enableClear
          />
          <FormSelect
            v-if="!disableCourseGrade"
            placeholder="selectGrade"
            :fieldValue.sync="changeLessonFilter.grade"
            :options="gradeOptions"
            hideDetails
            :readonly="isSearching"
            @changed="onChangeLessonFilterChange()"
            class="mr-3 mb-3"
            enableClear
          />
        </v-toolbar-items>
      </v-toolbar>

      <CustomTimetable
        ref="timetable"
        :loading="isSearching"
        :timetableData="searchTableData"
        @dates-update="onTimetableChange($event)"
        @type-update="changeLessonFilter.timetableType = $event"
        :holidayData="holidayList"
        @event-clicked="handleChangeLesson($event)"
        noDataText="calendar.noLesson"
      >
        <template v-slot:[`event`]="{ event }">
          <TimetableEventCard :eventData="event" :expandStudent="false" showStatus />
        </template>
      </CustomTimetable>
    </DialogLayout>

    <!-- Modal: 修改課程其他課堂 -->
    <FormDialog ref="editFormDialog" formRef="editForm" title="lessonInfo" :maxWidth="600">
      <v-row class="ma-0">
        <v-col class="py-0" cols="12" sm="6" v-if="isSingleEditLesson()">
          <FormDatePicker
            label="date"
            :dateValue.sync="editFormData.date"
            required
            disabledActionButtons
            disableClear
            :holidayData="holidayList"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="6">
          <FormRangeTimePicker
            label="time"
            :startTimeValue.sync="editFormData.start_time"
            :endTimeValue.sync="editFormData.end_time"
            :required="editIsRequired"
            dispatchUpdateOnChange
            :readonly="!canEdit"
          />
        </v-col>

        <v-col class="py-0" cols="12" sm="6">
          <FormSelect
            v-if="isAppMode(['T01', 'T16'])"
            label="tutor"
            :fieldValue.sync="editFormData.tutor_id"
            :required="editIsRequired && !isAppMode(['T02'])"
            :options="tutorOptions"
            :enableClear="!editIsRequired || isAppMode(['T02'])"
            :isLoading="tutorOptionsLoading"
          />
          <FormSelect
            v-else
            label="tutor"
            :fieldValue.sync="editFormData.tutor_id_list"
            :required="editIsRequired && !isAppMode(['T02'])"
            :options="tutorOptions"
            isMultiple
            :isLoading="tutorOptionsLoading"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="6">
          <FormSelect
            label="classroom"
            :fieldValue.sync="editFormData.classroom_id"
            :required="editIsRequired && !isAppMode(['T16'])"
            :options="classroomOptions"
            :enableClear="!editIsRequired || isAppMode(['T16'])"
            :isLoading="classroomLoading"
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 新增其他課堂 -->
    <FormDialog ref="addLessonFormDialog" formRef="addLessonForm" title="addOtherLesson" :maxWidth="600">
      <v-row class="ma-0">
        <v-col class="py-0" cols="12" sm="6">
          <FormSelect
            label="addLessonType"
            placeholder="selectAddLessonType"
            :fieldValue.sync="addOtherLessonType"
            :options="addOtherLessonTypeOptions"
            @changed="addOtherLessonValue = ''"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="6" v-if="addOtherLessonType === 'lesson_count'">
          <FormInput
            label="addLessonCount"
            :fieldValue.sync="addOtherLessonValue"
            type="number"
            required
            isIntegerOnly
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="6" v-else-if="addOtherLessonType === 'end_date'">
          <FormDatePicker
            label="courseEndDate"
            :dateValue.sync="addOtherLessonValue"
            :minDate="lastLessonDate"
            required
            :holidayData="holidayList"
            disabledActionButtons
          />
        </v-col>
      </v-row>
      <v-row class="ma-0" v-if="addOtherLessonType === 'custom'">
        <v-col class="py-0" cols="12" sm="6">
          <FormDatePicker
            label="date"
            :dateValue.sync="addOtherLessonCustom.date"
            required
            disabledActionButtons
            :customRules="[v => checkLessonDateValid(addOtherLessonCustom.date)]"
            :holidayData="holidayList"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="6">
          <FormRangeTimePicker
            label="time"
            :startTimeValue.sync="addOtherLessonCustom.start_time"
            :endTimeValue.sync="addOtherLessonCustom.end_time"
            :required="editIsRequired"
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 新增學生 -->
    <DialogLayout ref="addStudentActionDialog" title="addStudent" hideAction cardContentClass="pa-0" :maxWidth="500">
      <div class="px-4 py-10 d-flex align-center justify-center">
        <FormButton text="addStudentForPackage" @click="searchStudentOpen('new')" class="mr-2" />
        <FormButton text="switchToThisLesson" @click="searchStudentOpen('switch')" />
      </div>
    </DialogLayout>

    <!-- Modal: 新增學生(扣除套票) / 調堂到此課堂 search student -->
    <DialogLayout ref="addStudentDialog" title="addStudent" hideAction cardContentClass="pa-0">
      <div class="pa-4">
        <v-row class="ma-0 my-4">
          <v-col cols="12" sm="6">
            <Searchbar
              :isSearching="isSearching"
              label="searchStudent"
              :searchText.sync="addStudentFilter.keyword"
              @search-clicked="onAddStudentFilterChange()"
              :searchType.sync="addStudentFilter.keywordType"
              :searchTypeOptions="addStudentSearchTypeOptions"
              enableMultiTypeSearch
              enableClear
            />
          </v-col>
        </v-row>
      </div>

      <Datatable
        :isLoading="isSearching"
        :tableData="addStudentSearchTableData"
        :tableHeaders="addStudentHeaders"
        :itemTotal="addStudentSearchTotal"
        :page.sync="addStudentSearchTableOptions.tablePage"
        :pageLimit.sync="addStudentSearchTableOptions.tableLimit"
        :pageLimitOptions="addStudentSearchTableOptions.limitOptions"
        @options-update="searchStudents()"
      >
        <template v-slot:[`item.actionAddStudent`]="{ item }">
          <v-btn
            v-if="addStudentFilter.type === 'new' && (!item.existed || item.unpaid)"
            :loading="$store.getters.isLoading"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleAddStudent(item.id)"
            >{{ $t(item.existed && item.unpaid ? 'payTuition' : 'add') }}</v-btn
          >
          <v-btn
            v-else-if="addStudentFilter.type === 'switch' && !item.existed"
            :loading="$store.getters.isLoading"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="searchStudentLessonOpen(item.id)"
            >{{ $t('select') }}</v-btn
          >
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: 調堂到此課堂 search lesson -->
    <DialogLayout ref="addStudentSwitchDialog" title="chooseLesson" hideAction cardContentClass="pa-0">
      <div class="pa-4">
        <v-row class="ma-0 my-4">
          <v-col cols="12" sm="6">
            <FormDatePicker
              label="lessonDate"
              placeholder="selectLessonDate"
              :dateValue.sync="changeLessonFilter.date"
              @changed="onAddStudentSwitchFilterChange()"
              hideDetails
              :holidayData="holidayList"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <FormSelect
              label="tutor"
              placeholder="selectTutor"
              :fieldValue.sync="changeLessonFilter.tutor"
              :options="changeLessonTutorOptions"
              hideDetails
              :readonly="isSearching"
              @changed="onAddStudentSwitchFilterChange()"
              enableClear
            />
          </v-col>
          <v-col cols="12" sm="6" v-if="!disableCourseGrade">
            <FormSelect
              label="grade"
              placeholder="selectGrade"
              :fieldValue.sync="changeLessonFilter.grade"
              :options="gradeOptions"
              hideDetails
              :readonly="isSearching"
              @changed="onAddStudentSwitchFilterChange()"
              enableClear
            />
          </v-col>
        </v-row>
      </div>

      <Datatable
        :isLoading="isSearching"
        :tableData="searchTableData"
        :tableHeaders="addStudentSwitchHeaders"
        :itemTotal="searchTableTotal"
        :page.sync="searchTableOptions.tablePage"
        :pageLimit.sync="searchTableOptions.tableLimit"
        :pageLimitOptions="searchTableOptions.limitOptions"
        @options-update="searchStudentExistLesson()"
        tableEmptyText="calendar.noLesson"
      >
        <template v-slot:[`item.actionSelect`]="{ item }">
          <v-btn
            v-if="item.canSwitch"
            :loading="$store.getters.isLoading"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="switchStudentToThisLesson(item.id)"
            >{{ $t('switchToThisLesson') }}</v-btn
          >
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: 導師薪酬計算 -->
    <FormDialog ref="tutorFormDialog" formRef="tutorForm" title="editTutorSalary" :maxWidth="600">
      <v-row class="ma-0">
        <v-col class="py-0" cols="12" sm="6">
          <FormSelect
            label="salaryMethodType"
            placeholder="selectSalaryMethod"
            :fieldValue.sync="tutorSalaryData.salary_method"
            :options="$salaryTypeOptions"
            required
            @changed="onSalaryMethodChanged()"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="6" v-if="tutorSalaryData.salary_method === 'level'">
          <FormSelect
            label="salaryLevel"
            placeholder="selectSalaryLevel"
            :fieldValue.sync="tutorSalaryData.salary_level"
            :options="salaryLevelOptions"
            required
          />
        </v-col>
        <template v-else-if="tutorSalaryData.salary_method === 'percentage'">
          <v-col class="py-0" cols="12" sm="6">
            <FormInput
              type="number"
              label="sharePercentage"
              :fieldValue.sync="tutorSalaryData.percentage"
              suffix="%"
              required
            />
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <FormInput type="number" label="minSalary" :fieldValue.sync="tutorSalaryData.min_salary" prefix="HK$" />
          </v-col>
        </template>
        <template v-else-if="tutorSalaryData.salary_method === 'hour'">
          <v-col class="py-0" cols="12" sm="6">
            <FormInput
              type="number"
              label="hourlyWage"
              :fieldValue.sync="tutorSalaryData.salary_per_hour"
              prefix="HK$"
              suffix="perHour"
            />
          </v-col>
        </template>
        <template v-if="isAppMode(['T21'])">
          <v-col class="py-0" cols="12" sm="6">
            <FormInput type="number" label="bonusRnD" :fieldValue.sync="tutorSalaryData.bonus_rnd" prefix="HK$" />
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <FormInput
              type="number"
              label="bonusPerformance"
              :fieldValue.sync="tutorSalaryData.bonus_performance"
              prefix="HK$"
            />
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <FormInput
              type="number"
              label="bonusAttendance"
              :fieldValue.sync="tutorSalaryData.bonus_attendance"
              prefix="HK$"
            />
          </v-col>
        </template>
      </v-row>
    </FormDialog>

    <!-- Modal: 課堂進度 -->
    <DialogLayout ref="lessonProgressDialog" title="lessonProgress" hideAction cardContentClass="pa-0">
      <Datatable
        :isLoading="progressTable.loading"
        :tableData="progressTable.list"
        :tableHeaders="progressTableHeaders"
        :itemTotal="progressTable.total"
        :page.sync="progressTable.page"
        :pageLimit.sync="progressTable.limit"
        @options-update="getProgressData()"
        @edit-clicked="handleAddProgress(progressTable.student_id, $event)"
        @delete-clicked="handleDeleteProgress($event)"
      >
        <template slot="append-toolbar-left">
          <FormButton
            v-if="canTutorEdit"
            text="add"
            isAdd
            class="my-2"
            @click="handleAddProgress(progressTable.student_id)"
          />
        </template>
        <template v-slot:[`item.video_url`]="{ item }">
          <v-btn
            v-if="item.video_url"
            @click.prevent="previewVideo(item.video_url)"
            text
            depressed
            small
            color="primary"
          >
            {{ item.custom_video_title || item.video_title || '' }}
          </v-btn>
        </template>
      </Datatable>
    </DialogLayout>
    <!-- Modal: 新增課堂進度 -->
    <FormDialog ref="progressDialog" formRef="progressForm" title="lessonProgress" :maxWidth="500">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="lessonProgressInput" :fieldValue.sync="progressData.progress" required />
        </v-col>
        <v-col cols="12">
          <FormInput label="commentInput" :fieldValue.sync="progressData.comment" />
        </v-col>
      </v-row>
      <v-row class="ma-0" v-if="gEnableLessonProgressVideo">
        <v-col cols="12">
          <FormUploader
            ref="uploadProgressVideoRef"
            fileInputKey="upload_progress_video"
            :files.sync="progressData.video_list"
            :acceptFormat="['vimeo']"
            single
          />
        </v-col>
        <v-col cols="12" class="d-flex">
          <FormButton @click="pasteVideo()" text="pasteVideo" />
          <FormButton
            v-if="$validate.DataValid(progressData.video_list, true) && progressData.video_list[0].video_id"
            @click="copyVideo()"
            text="copyVideo"
            class="ml-2"
          />
          <FormButton text="searchVideo" @click="openSearchVideo()" class="ml-2" />
        </v-col>
      </v-row>
    </FormDialog>
    <!-- Modal: 搜尋影片 -->
    <DialogLayout ref="searchVideoDialog" title="searchVideo" hideAction cardContentClass="pa-0">
      <Datatable
        :isLoading="videoTable.loading"
        :tableData="videoTable.list"
        :tableHeaders="videoTableHeaders"
        :itemTotal="videoTable.total"
        :page.sync="videoTable.page"
        :pageLimit.sync="videoTable.limit"
        @options-update="searchVideo()"
      >
        <template v-slot:[`item.thumbnail`]="{ item }">
          <v-img :src="item.thumbnail" contain :max-height="200" :max-width="200"></v-img>
        </template>
        <template v-slot:[`item.duration`]="{ item }">{{ gfConvertDuration(item.duration) }}</template>
        <template v-slot:[`item.video_url`]="{ item }">
          <v-btn
            v-if="item.videoInput.url"
            @click.prevent="previewVideo(item.videoInput.url)"
            text
            depressed
            small
            color="primary"
          >
            {{ item.videoInput.name }}
          </v-btn>
        </template>
        <template v-slot:[`item.actionSelect`]="{ item }">
          <v-btn
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleSelectVideo(item)"
          >
            {{ $t('select') }}
          </v-btn>
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: 請假備註 -->
    <DialogLayout ref="leaveRemarkDialog" title="leaveRemark" hideAction cardContentClass="pa-0">
      <Datatable
        :isLoading="leaveTable.loading"
        :tableData="leaveTable.list"
        :tableHeaders="leaveRemarkTableHeaders"
        :itemTotal="leaveTable.total"
        :page.sync="leaveTable.page"
        :pageLimit.sync="leaveTable.limit"
        @options-update="getLeaveRemarkData()"
        @edit-clicked="handleAddLeaveRemark(leaveTable.student_id, $event)"
      >
        <template slot="append-toolbar-left">
          <FormButton
            v-if="canTutorEdit"
            text="add"
            isAdd
            class="my-2"
            @click="handleAddLeaveRemark(leaveTable.student_id)"
          />
        </template>
      </Datatable>
    </DialogLayout>
    <!-- Modal: 新增請假備註 -->
    <FormDialog ref="addLeaveRemarkDialog" formRef="leaveRemarkForm" title="leaveRemark" :maxWidth="500">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="remark" :fieldValue.sync="leaveData.comment" />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: WhatsApp -->
    <FormDialog ref="selectWtsDialog" formRef="selectWtsForm" title="selectWhatsappPhone" :maxWidth="500">
      <v-row class="ma-0">
        <v-col cols="12" style="white-space: pre-line;">{{ wtsMsg }}</v-col>
        <v-col cols="12">
          <v-radio-group
            name="selectWhatsappPhone"
            v-model="wtsPhone"
            class="ma-0"
            :rules="[v => this.$validate.required(v)]"
          >
            <v-radio
              v-for="(item, index) in wstPhoneOptions"
              :label="item.text"
              :value="item.value"
              :key="index"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Alert: 是否修改課堂？ -->
    <DialogLayout
      ref="confirmEditLesson"
      title="message.confirmEditLesson"
      :maxWidth="600"
      hideAction
      :enableClose="false"
    >
      <v-card-actions class="mt-6 justify-center flex-wrap">
        <FormButton class="mb-2" text="onlyEditThisLesson" @click="editClassSettingSubmit('one')" />
        <FormButton class="mb-2" text="editAllLessons" @click="editClassSettingSubmit('all')" />
        <FormButton class="mb-2" text="editAllLessonsAfter" @click="editClassSettingSubmit('all_after')" />
        <FormButton class="mb-2" color="darken-1" outlined text="cancel" @click="editClassSettingSubmit()" />
      </v-card-actions>
    </DialogLayout>

    <!-- Alert: 是否修改導師薪酬計算？ -->
    <DialogLayout
      ref="confirmEditTutorSalary"
      title="message.confirmEditTutorSalary"
      :maxWidth="600"
      hideAction
      :enableClose="false"
    >
      <div>{{ $t('message.confirmEditTutorSalaryMsg') }}</div>
      <v-card-actions class="mt-6 justify-center flex-wrap">
        <FormButton class="mb-2" text="onlyEditThisLesson" @click="tutorSalarySubmit('one')" />
        <FormButton class="mb-2" text="editAllLessons" @click="tutorSalarySubmit('all')" />
        <FormButton class="mb-2" text="editAllLessonsAfter" @click="tutorSalarySubmit('all_after')" />
        <FormButton class="mb-2" color="darken-1" outlined text="cancel" @click="tutorSalarySubmit()" />
      </v-card-actions>
    </DialogLayout>
  </v-container>
</template>

<script>
import { mdiTimetable, mdiOpenInNew, mdiWhatsapp } from '@mdi/js'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import Searchbar from '@/components/Searchbar.vue'
import ExcelMixin from '@/mixins/ExcelMixin.vue'
import FormInput from '@/components/formField/FormInput.vue'
import CourseColorPicker from '@/components/CourseColorPicker.vue'
import QuillEditor from '@/components/formField/QuillEditor.vue'
import CustomTimetable from '@/components/CustomTimetable.vue'
import TimetableEventCard from '@/components/layout/TimetableEventCard.vue'
import TableDropdown from '@/components/layout/TableDropdown.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormRangeTimePicker from '@/components/formField/FormRangeTimePicker.vue'
import FormTextarea from '@/components/formField/FormTextarea.vue'
import LogTable from '@/components/LogTable.vue'

export default {
  name: 'ClassDetails',
  inject: ['getConfirmDialogRef'],
  mixins: [ExcelMixin],
  components: {
    FormDatePicker,
    FormSelect,
    Datatable,
    DialogLayout,
    Searchbar,
    FormInput,
    CourseColorPicker,
    QuillEditor,
    CustomTimetable,
    TimetableEventCard,
    TableDropdown,
    FormUploader,
    FormDialog,
    FormRangeTimePicker,
    FormTextarea,
    LogTable,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    pageTitle() {
      return `${this.staticLessonInfo.course_name} ${this.staticLessonInfo.date.replace(/-/g, '/')}${
        this.staticLessonInfo.date
          ? ` (${this.$d(this.$formatter.convertDate(this.staticLessonInfo.date), 'weekdayShort')})`
          : ''
      }`
    },
    timeSlotError() {
      return !this.$validate.DataValid(this.formData.start_time) || !this.$validate.DataValid(this.formData.end_time)
    },
    addOtherLessonTypeOptions() {
      const options = [
        { value: 'lesson_count', text: this.$t('addLessonCount') },
        { value: 'end_date', text: this.$t('courseEndDate') },
      ]

      // Class details 新增其他課堂可以直接custom date&time
      if (!this.isAppMode(['T01'])) {
        options.push({ value: 'custom', text: this.$t('customDateTime') })
      }

      return options
    },
    searchTypeOptions() {
      const vm = this
      const headers = [{ value: 'course_name', text: vm.$t('courseName') }]
      if (this.gDisableEmptyCode) {
        headers.push({ value: 'course_code', text: vm.$t('courseCode') })
      }
      return headers
    },
    changeLessonHeaders() {
      const vm = this
      let headers = [
        { value: 'course_name', text: vm.$t('courseName'), width: 250 },
        { value: 'full_date', text: vm.$t('date'), hasWeekday: true },
        { value: 'timeslot', text: vm.$t('time') },
      ]
      if (!this.disableCourseGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }
      headers = [
        ...headers,
        { value: 'tutor', text: vm.$t('tutor') },
        { value: 'current_per_max_student_num', text: vm.$t('personCount') },
        { value: 'actionSelectChangeLesson', text: '', align: 'end' },
      ]
      return headers
    },
    addStudentSwitchHeaders() {
      const vm = this
      let headers = [
        { value: 'course_name', text: vm.$t('courseName') },
        { value: 'full_date', text: vm.$t('date'), hasWeekday: true },
        { value: 'timeslot', text: vm.$t('time') },
      ]
      if (!this.disableCourseGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }
      headers = [
        ...headers,
        { value: 'tutor', text: vm.$t('tutor') },
        { value: 'actionSelect', text: '', align: 'end' },
      ]
      return headers
    },
    otherClassTableHeaders() {
      const vm = this
      let headers = [
        { value: 'course_name', text: vm.$t('course') },
        { value: 'weekday', text: vm.$t('weekday') },
        { value: 'full_date', text: vm.$t('date') },
        { value: 'timeslot', text: vm.$t('time') },
      ]
      if (!this.disableCourseGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }
      headers = [
        ...headers,
        { value: 'current_per_max_student_num', text: vm.$t('studentCount'), hasUnit: true },
        { value: 'actionViewCustom', text: '', align: 'end' },
      ]
      if (this.canEdit) {
        headers.push({ value: 'minActionEditAndDelete', text: '', align: 'end', width: 140 })
      }
      return headers
    },
    startDateMin() {
      const d = this.$formatter.convertDate()
      if (this.isAppMode(['T17'])) {
        d.setDate(d.getDate() - 30)
      } else if (this.isAppMode(['T14'])) {
        d.setDate(1)
        d.setMonth(d.getMonth() - 1)
      }

      return this.$formatter.formatDate(d)
    },
    tutorTableHeaders() {
      let headers = [{ value: 'name', text: this.$t('tutor'), width: 200 }]
      if (this.canViewSalary) {
        headers.push({ value: 'salary_method', text: this.$t('salaryMethodType') })
        headers.push({ value: 'min_salary', text: `${this.$t('minSalary')} (HK$)` })

        if (this.isAppMode(['T21'])) {
          headers = [
            ...headers,
            { value: 'bonus_rnd', text: `${this.$t('bonusRnD')} (HK$)` },
            { value: 'bonus_performance', text: `${this.$t('bonusPerformance')} (HK$)` },
            { value: 'bonus_attendance', text: `${this.$t('bonusAttendance')} (HK$)` },
            { value: 'total_bonus', text: `${this.$t('totalBonus')} (HK$)` },
          ]
        }
      }

      if (this.enableTutorAttendance) {
        headers.push({ value: 'attend_status', text: this.$t('attendStatus') })
      }

      if (this.canViewSalary && this.canEdit) {
        headers.push({ value: 'minActionEdit', text: '', align: 'end' })
      }
      return headers
    },
    progressTableHeaders() {
      const vm = this
      const headers = [
        { value: 'create_date', text: vm.$t('date'), width: 130 },
        { value: 'progress', text: vm.$t('lessonProgress') },
        { value: 'comment', text: vm.$t('comment') },
      ]
      if (this.gEnableLessonProgressVideo) {
        headers.push({ value: 'video_url', text: vm.$t('uploadVideo') })
      }
      if (this.canTutorEdit) {
        // headers.push({ value: 'minActionEditAndDelete', text: '', align: 'end' })
        headers.push({ value: 'minActionEdit', text: '', align: 'end' })
      }
      return headers
    },
    leaveRemarkTableHeaders() {
      const vm = this
      const headers = [
        { value: 'create_date', text: vm.$t('createdDate'), width: 130 },
        { value: 'comment', text: vm.$t('remark') },
      ]
      if (this.canTutorEdit) {
        headers.push({ value: 'minActionEdit', text: '', align: 'end' })
      }
      return headers
    },
    locale() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en'
        case 'cn':
          return 'zh-CN'
        default:
          return 'zh-HK'
      }
    },
    addStudentHeaders() {
      const vm = this
      let headers = [{ value: 'student_code', text: vm.$t('studentCode') }]
      if (!this.gDisableStudentGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }
      headers = [
        ...headers,
        { value: 'student_name', text: vm.$t('name') },
        { value: 'phone', text: vm.$t('phone') },
        { value: 'actionAddStudent', text: '', align: 'end' },
      ]
      return headers
    },
    gradeOptions() {
      return this.$store.getters.gradeOptions
    },
    addStudentSearchTypeOptions() {
      const vm = this
      let options = [
        { value: 'name', text: vm.$t('studentName') },
        { value: 'phone', text: vm.$t('phone') },
      ]

      if (this.isAppMode(['T40'])) {
        options.unshift({ value: 'student_code', text: vm.$t('studentCode') })
      } else {
        options.push({ value: 'student_code', text: vm.$t('studentCode') })
      }
      if (this.isAppMode(['T64'])) {
        options.push({ value: 'student_field_12', text: vm.$t('email') })
      }

      return options
    },
    // permission / setting
    enableMultipleSkip() {
      return !this.isAppMode(['T01'])
    },
    enableUndoSwitch() {
      // TODO: 回復轉堂動作
      return this.isAppMode(['DEV', 'UAT', 'T61', '44+'])
      return !this.isAppMode(['T01'])
    },
    enableUndoSkip() {
      // TODO #390: 回復跳堂動作
      return this.isAppMode(['DEV', 'UAT', 'T61', '44+'])
      return !this.isAppMode(['T01'])
    },
    enableTutorAttendance() {
      return this.isAppMode(['DEV', 'UAT', 'T40'])
    },
    canEdit() {
      return this.$validate.allowAction('editClass', this.userType)
    },
    canTakeAttendance() {
      return this.$validate.allowAction('editAttendance', this.userType)
    },
    canConfirmTutorAttendance() {
      return this.$validate.allowAction('canAuditLeave', this.userType)
    },
    // 課堂進度/請假備註/備註/上載教材
    canTutorEdit() {
      return this.canEdit || (this.isAppMode(['T46','T47','T49','T61']) && this.userType === 'tutor')
    },
    canViewStudent() {
      return this.$validate.allowAction('StudentDetails', this.userType)
    },
    canViewSalary() {
      return this.$validate.allowAction('viewSalary', this.userType)
    },
    // 修改課堂 / 新增一個單一課堂
    canEditClassDetail() {
      if (this.canEdit) {
        if (this.isAppMode(['T30']) && this.userType === 'tutor') {
          return false
        }
      }
      return this.canEdit
    },
    // 新增學生
    canAddStudent() {
      if (this.canEdit) {
        if (this.isAppMode(['T38']) && this.userType === 'tutor') {
          return false
        }
      } else {
        if (this.isAppMode(['T30']) && this.userType === 'tutor') {
          return true
        }
      }

      return this.canEdit
    },
    // 跳堂
    canSkip() {
      // T46 tutor account hidden 跳堂
      return !this.isAppMode(['T46']) || this.userType !== 'tutor'
    },
    canViewLog() {
      return this.gEnableLog && this.$validate.allowAction('viewLog', this.userType)
    },
  },
  watch: {
    datePickerDisplay() {
      const open = this.$refs && this.$refs.changeLessonDialog ? this.$refs.changeLessonDialog.isOpen() : false
      if (open && this.startSearching) {
        this.onDatePickerChange()
      }
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    disableCourseGrade: false,
    tableLoading: false,
    otherLessonTableLoading: false,
    exportLoading: false,
    tutorOptions: [],
    tutorOptionsLoading: false,
    classroomOptions: [],
    classroomLoading: false,
    staticLessonInfo: {
      course_id: -1,
      course_name: '',
      course_code: '',
      date: '',
      lesson_type: '',
      school_id: null,
      grade: '',
      regular_id: -1,
      package_used_student_id_list: [],
      dropped_student_ids: [],
      paid_student_ids: [],
      start_time: '',
      end_time: '',

      price: '',
      tutor_id: '',
      tutor_id_list: [],
      classroom_id: null,
      color: '',
      salary_method: 'by_lesson',
      current_student_num: 0,
      max_student: 1,
      thumbnail_image_list: [],
      course_description: '',
      salary_level: null,
      multi_salary_level: [],
      salary_type: [],
      salary_per_hour: [],
      salary_percentage: [],
      show_website: false,
      attachment_list: [],

      // for T04
      school_type: '',

      // only for T16
      t16_salary: '',
      t16_salary_percentage: '',
      t16_salary_per_hour: '',
      t16_salary_type: null,

      // for T21
      salary_bonus: [],
    },

    formData: {
      date: '',
      start_time: '',
      end_time: '',
      attachment_list: [],
      remark: '',
      vimeo_attachment_list: [],
    },

    studentTableData: [],
    rawAttendance: [],

    otherLessonTableData: [],
    otherLessonSelectedRow: [],
    otherLessonData: [],
    addOtherLessonValue: '',
    addOtherLessonCustom: {
      date: '',
      start_time: '',
      end_time: '',
    },
    addOtherLessonType: 'lesson_count',
    lastLessonDate: '',

    editIsRequired: false,
    editFormData: {
      date: '',
      start_time: '',
      end_time: '',
      tutor_id: '',
      tutor_id_list: [],
      classroom_id: null,
    },

    isSearching: false,
    searchTableData: [],
    searchTableTotal: 0,
    searchTableOptions: {
      limitOptions: [5, 10, 20],
      tableLimit: 5,
      tablePage: 1,
    },
    changeLessonStudentId: null,
    appliedLessonIds: [],
    changeLessonFilter: {
      type: '', // 'all' | 'single'
      keyword: '',
      keywordType: 'course_name',
      dateRange: [],
      date: '',
      tutor: '',
      grade: '',
      mode: 'calendar', // 'calendar' | 'list' | 'timetable'
      timetableType: 'month',
    },
    changeLessonTutorOptions: [],
    allCourseNameOptions: [],
    courseNameOptionsInit: true,
    courseNameOptions: [],
    courseNameSearching: false,
    datePickerDisplay: '',
    startSearching: false,

    classData: {
      course_id: null,
      course_name: '',
      price: '',
      tutor_id: '',
      tutor_id_list: [],
      classroom_id: null,
      color: '',
      salary_method: 'by_lesson',
      max_student: 1,
      thumbnail_image_list: [],
      course_description: '',
      salary_level: null,
      show_website: false,
      attachment_list: [],
      // for T04
      school_type: '',

      // only for T16
      t16_salary: '',
      t16_salary_percentage: '',
      t16_salary_per_hour: '',
      t16_salary_type: null,

      // for new single lesson
      course_code: '',
      date: '',
      start_time: '',
      end_time: '',
    },
    courseOptions: [],
    maxStudentOptions: [],
    courseOptionLoading: false,

    addStudentFilter: {
      type: '', // new | switch
      keyword: '',
      keywordType: 'name',
    },
    addStudentSearchTableData: [],
    addStudentSearchTotal: 0,
    addStudentSearchTableOptions: {
      limitOptions: [5, 10, 20],
      tableLimit: 5,
      tablePage: 1,
    },
    addStudentSwitchInfo: {
      student_name: '',
    },

    // -- multiple tutors
    tutorTableLoading: false,
    tutorTableData: [],
    tutorSalaryData: {
      salary_method: 'level',
      salary_level: '',
      min_salary: '',
      percentage: '',
      salary_per_hour: '',
      // -- for T21 only
      bonus_rnd: '',
      bonus_performance: '',
      bonus_attendance: '',
    },

    progressData: {
      progress: '',
      comment: '',
      video_list: [],
    },
    progressTable: {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      student_id: -1,
    },
    videoTable: {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      limit: 10,
    },

    responsePerson: '',

    leaveData: {
      comment: '',
    },
    leaveTable: {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      student_id: -1,
    },

    wtsPhone: null,
    wstPhoneOptions: [],
    wtsMsg: '',

    logLoading: false,
    logTableData: [],
    logTableTotal: 0,

    // --- static data
    icon: {
      mdiTimetable,
      mdiOpenInNew,
      mdiWhatsapp,
    },
    studentTableHeaders: [
      { value: 'class_student_name', text: vm.$t('studentName'), width: 130 },
      { value: 'attend_status', text: vm.$t('attendStatus'), width: vm.$i18n.locale === 'en' ? 450 : 400 },
      { value: 'switch_from', text: vm.$t('switchLessonRecord'), width: vm.$i18n.locale === 'en' ? 200 : 150 },
      { value: 'actionTransfer', text: '', align: 'end' },
    ],
    displayOnlineOptions: [
      { value: true, text: vm.$t('display') },
      { value: false, text: vm.$t('notDisplay') },
    ],
    holidayList: [],
    schoolTypeOptions: [
      { value: 'A', text: vm.$t('lessonSchoolTypeOptions.A') },
      { value: 'B', text: vm.$t('lessonSchoolTypeOptions.B') },
      { value: 'all', text: vm.$t('lessonSchoolTypeOptions.all') },
    ],
    videoTableHeaders: [
      { value: 'thumbnail', text: vm.$t('videoCover'), width: 230 },
      { value: 'duration', text: vm.$t('videoDuration') },
      { value: 'video_url', text: vm.$t('video') },
      { value: 'actionSelect', text: '', align: 'end', width: 120 },
    ],
    salaryLevelOptions: [],
  }),
  methods: {
    async getLessonById() {
      this.tableLoading = true
      this.tutorTableLoading = true
      try {
        if (this.$validate.DataValid(this.id)) {
          const data = await this.$Fetcher.GetLessonById(this.id)
          for (const key in this.formData) {
            if (this.$validate.DataValid(data[key])) {
              this.formData[key] = data[key]
            }
          }
          this.formData.vimeo_attachment_list = []
          if (this.$validate.DataValid(data.video_attachment_id)) {
            this.formData.vimeo_attachment_list.push({
              is_vimeo: true,
              name: data.video_attachment_name,
              file: null,
              url: data.video_attachment_url,
              video_id: data.video_attachment_id,
            })
          }

          // tutor只可檢視自己教嘅lesson
          if (this.gTutorViewOwnLessonOnly && this.userType === 'tutor') {
            const getUser = this.gfGetCurrentUserData()
            if (!data.tutor_id_list.includes(getUser.id)) {
              this.permissionValid = false
              throw 'noPermission'
            }
          }

          // staff只可以access所屬分校lesson
          if (this.$validate.DataValid(data.school_id)) {
            const getUserSchools = this.gfGetUserSchools()
            if (!getUserSchools.includes(data.school_id)) {
              this.permissionValid = false
              throw 'message.notBelongLessonBranch'
            }
          }

          await this._getSetting()
          await this._getHolidays()
          this._insertStaticInfo(data)
          this.$store.dispatch('toggleLoadingPage', false)

          let next = await this.getStudentAttendance()
          if (next) await this.getOtherLessons()
        } else {
          throw 'noData'
        }
      } catch (err) {
        this.$common.error(err)

        this.tableLoading = false
        this.tutorTableLoading = false
        this.$store.dispatch('toggleLoadingPage', false)
        if (err === 'abort') {
          return false
        } else {
          this.showAlert({
            message: err,
            returnLink: 'Timetable',
            isError: true,
          })
        }
      }

      return true
    },
    async _getSetting() {
      let data = null
      if (this.gEnableCustomGrade) {
        try {
          data = await this.$Fetcher.GetSetting()
        } catch (err) {
          this.$common.error(err)
        }
      }
      this.disableCourseGrade = this.gfCheckDisabledCourseGrade(data)
    },
    async _getHolidays() {
      if (this.$validate.DataValid(this.$excludeMenuList) && this.$excludeMenuList.includes('setting-holiday')) return
      try {
        const selectedSchool = this.gfGetUserSelectedSchool()
        this.holidayList = await this.$Fetcher.GetHolidaysWithCenter(selectedSchool)
      } catch {}
    },
    async _getTutorOptions() {
      this.tutorOptionsLoading = true
      this.tutorOptions = []
      try {
        let payload = {}
        if (this.$validate.DataValid(this.staticLessonInfo.school_id)) {
          payload['center'] = [this.staticLessonInfo.school_id]
        }

        const { data } = await this.$Fetcher.GetStaffs(payload)
        this.tutorOptions = data.map(el => {
          return {
            value: el.id,
            text: el.name,
            ...el,
          }
        })

        this.changeLessonTutorOptions = [{ value: -1, text: this.$t('allTutors') }, ...this.tutorOptions]
      } catch {}

      this.tutorOptionsLoading = false
    },
    async _getClassroomOptions() {
      this.classroomOptions = []
      this.classroomLoading = true
      try {
        let payload = {}
        if (this.$validate.DataValid(this.staticLessonInfo.school_id)) {
          payload['center_id'] = this.staticLessonInfo.school_id
        }

        const { data } = await this.$Fetcher.GetClassrooms(payload)
        this.classroomOptions = data.map(el => {
          return {
            value: el.id,
            text: el.name,
          }
        })
      } catch {}
      this.classroomLoading = false
    },

    async getStudentAttendance() {
      this.tableLoading = true
      this.tutorTableLoading = true
      try {
        const data = await this.$Fetcher.GetLessonById(this.id, {
          join_student_data: true,
          join_student_last_lesson: true,
          join_attendance_data: true,
        })

        this._insertStaticInfo(data)

        this.rawAttendance = data.raw_attendance_list
        this.studentTableData = data.attendance_list.filter(item => item.status !== "drop").map(item => {
          return {
            ...item,
            id: item.student_id,
            class_student_name:
              item.student_name +
              (this.isAppMode(['T46']) ? ` ${item.student_nickname} (${this.gfGetGradeText(item.grade)})` : ''),
            attend_status: item.status,
            switch_from: item.switch_from ? item.switch_from : 'N/A',
            attend_time: item.attend_datetime ? item.attend_datetime.substring(11, 16) : '',
          }
        })
        console.log("this.studentTableData",this.studentTableData)
        if (this.isAppMode(['DEV', 'UAT', 'T27'])) {
          await this._getFeedbacks()
        }
        this.tableLoading = false
      } catch (err) {
        this.$common.error(err)
        this.studentTableData = []
        this.tutorTableLoading = false
        this.tableLoading = false
        if (err === 'abort') {
          return false
        }
      }

      return true
    },
    async _insertStaticInfo(data) {
      this.staticLessonInfo['thumbnail_image_list'] = []
      for (const key in this.staticLessonInfo) {
        if (data[key] !== undefined) {
          this.staticLessonInfo[key] = data[key]
        } else if (key === 'thumbnail_image_list' && data['thumbnail_image']) {
          this.staticLessonInfo[key].push({
            name: data['thumbnail_image'],
            file: data['thumbnail_image'],
          })
        }
      }

      this.tutorTableData = []
      if (!this.isAppMode(['T01', 'T16'])) {
        const tutorIds = this.staticLessonInfo.tutor_id_list
        for (let i = 0; i < tutorIds.length; i++) {
          let salary_method = ''
          let salary_level = ''
          let min_salary = 0
          let percentage = 0
          let salary_per_hour = 0
          let bonus_rnd = 0
          let bonus_performance = 0
          let bonus_attendance = 0

          const foundSalaryType = data.salary_type.find(el => el.staff_id === tutorIds[i])
          salary_method = foundSalaryType ? foundSalaryType.type : ''
          if (salary_method === 'level') {
            const foundSalaryLevel = data.multi_salary_level.find(el => el.staff_id === tutorIds[i])
            salary_level = foundSalaryLevel ? foundSalaryLevel.level : ''
          } else if (salary_method === 'hour') {
            const found = data.salary_per_hour.find(el => el.staff === tutorIds[i])
            salary_per_hour = found ? found.value : 0
          } else if (salary_method === 'percentage') {
            const found = data.salary_percentage.find(el => el.staff === tutorIds[i])
            if (found) {
              percentage = found.value
              min_salary = found.min
            }
          }

          const foundBonus = data.salary_bonus.find(el => el.staff_id === tutorIds[i])
          if (foundBonus) {
            bonus_rnd = foundBonus.rnd || 0
            bonus_performance = foundBonus.performance || 0
            bonus_attendance = foundBonus.attendance || 0
          }

          let foundAttendance = null
          for (let x = data.tutor_attendance.length - 1; x >= 0; x--) {
            if (data.tutor_attendance[x].staff_id === tutorIds[i]) {
              foundAttendance = data.tutor_attendance[x]
              break
            }
          }

          this.tutorTableData.push({
            id: tutorIds[i],
            name: '',
            salary_level: salary_level,
            salary_method: salary_method,
            min_salary: min_salary,
            percentage: percentage,
            salary_per_hour: salary_per_hour,
            default_salary_per_hour: 0,
            bonus_rnd: bonus_rnd,
            bonus_performance: bonus_performance,
            bonus_attendance: bonus_attendance,
            total_bonus: bonus_rnd + bonus_performance + bonus_attendance,
            salary_level_data: null,
            salary_level_price: 0,
            attend_status: foundAttendance ? foundAttendance.status : 'pending',
            init_attend_status: foundAttendance ? foundAttendance.status : 'pending',
            attend_time:
              foundAttendance && foundAttendance.status === 'attend' && foundAttendance.attend_time
                ? foundAttendance.attend_time.substring(11, 16)
                : '',
            attend_confirm_time: foundAttendance ? foundAttendance.confirm_time : '',
          })
        }
        if (tutorIds.length) {
          try {
            const tutorsList = await this.$Fetcher.GetStaffsByIdList(tutorIds)
            for (let i = 0; i < this.tutorTableData.length; i++) {
              const found = tutorsList.find(el => el.id === this.tutorTableData[i].id)
              if (found) {
                this.tutorTableData[i].name = found.name
                this.tutorTableData[i].default_salary_per_hour = found.salary_per_hour
                this.tutorTableData[i].salary_level_data = found.salary_level
                if (this.tutorTableData[i].salary_level && found.salary_level) {
                  this.tutorTableData[i].salary_level_price =
                    found.salary_level[this.tutorTableData[i].salary_level] || 0
                }
              }
            }
          } catch {}
        }
      }
      this.tutorTableLoading = false
    },
    async _getFeedbacks(count = 0) {
      if (count < this.studentTableData.length) {
        try {
          const data = await this.$Fetcher.GetLatestFeedback(this.studentTableData[count].id, this.id)
          this.studentTableData[count].feedback = data.comment
        } catch (err) {
          if (err === 'abort') {
            return
          }
        }

        count += 1
        this._getFeedbacks(count)
      }
    },
    enableViewStudent(sid) {
      if (!this.canViewStudent) return false
      if (this.gDisableStudentCenterFilter) return true

      const found = this.studentTableData.find(el => el.id === sid)
      if (this.$validate.DataValid(found.schools, true)) {
        let pass = false
        if (found.schools.includes(-1)) {
          pass = true
        }
        if (!pass) {
          const getUserSchools = this.gfGetUserSchools()
          for (let i = 0; i < found.schools.length; i++) {
            if (getUserSchools.includes(found.schools[i])) {
              pass = true
              break
            }
          }
        }
        return pass
      }

      return true
    },

    // --- cache timetable
    _removeCacheLessons(ids) {
      try {
        const cacheFilter = { ...this.$store.getters.timetableCache }
        if (cacheFilter && cacheFilter.mode === this.$appMode) {
          for (let i = 0; i < ids.length; i++) {
            const foundInDay = (cacheFilter.day.data || []).findIndex(el => el.id === ids[i])
            if (foundInDay > -1) {
              const newData = [...cacheFilter.day.data]
              newData.splice(foundInDay, 1)
              this.$store.dispatch('setTimetableCache', {
                key: 'day',
                data: newData,
                refreshExpired: false,
              })
            }

            const foundInWeek = (cacheFilter.week.data || []).findIndex(el => el.id === ids[i])
            if (foundInWeek > -1) {
              const newData = [...cacheFilter.week.data]
              newData.splice(foundInWeek, 1)
              this.$store.dispatch('setTimetableCache', {
                key: 'week',
                data: newData,
                refreshExpired: false,
              })
            }

            const foundInMonth = (cacheFilter.month.data || []).findIndex(el => el.id === ids[i])
            if (foundInMonth > -1) {
              const newData = [...cacheFilter.month.data]
              newData.splice(foundInMonth, 1)
              this.$store.dispatch('setTimetableCache', {
                key: 'month',
                data: newData,
                refreshExpired: false,
              })
            }
          }
        } else {
          throw null
        }
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setTimetableCache')
      }
    },

    _updateCacheTimetableLessons(payloads) {
      try {
        for (let i = 0; i < payloads.length; i++) {
          const cacheFilter = { ...this.$store.getters.timetableCache }
          if (cacheFilter && cacheFilter.mode === this.$appMode) {
            // day
            for (let x = 0; x < (cacheFilter.day.data || []).length; x++) {
              if (cacheFilter.day.data[x].id === payloads[i].id) {
                cacheFilter.day.data[x] = this._updateCacheLesson(payloads[i], cacheFilter.day.data[x])
                this.$store.dispatch('setTimetableCache', {
                  key: 'day',
                  data: cacheFilter.day.data,
                  refreshExpired: false,
                })
                break
              }
            }

            // week
            for (let x = 0; x < (cacheFilter.week.data || []).length; x++) {
              if (cacheFilter.week.data[x].id === payloads[i].id) {
                cacheFilter.week.data[x] = this._updateCacheLesson(payloads[i], cacheFilter.week.data[x])
                this.$store.dispatch('setTimetableCache', {
                  key: 'week',
                  data: cacheFilter.week.data,
                  refreshExpired: false,
                })
                break
              }
            }

            // month
            for (let x = 0; x < (cacheFilter.month.data || []).length; x++) {
              if (cacheFilter.month.data[x].id === payloads[i].id) {
                cacheFilter.month.data[x] = this._updateCacheLesson(payloads[i], cacheFilter.month.data[x])
                this.$store.dispatch('setTimetableCache', {
                  key: 'month',
                  data: cacheFilter.month.data,
                  refreshExpired: false,
                })
                break
              }
            }
          } else {
            throw null
          }
        }
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setTimetableCache')
      }
    },
    _updateCacheLesson(newUpdate, cacheData) {
      let _cacheData = { ...cacheData }
      if (newUpdate.date !== undefined) {
        _cacheData.date = newUpdate.date
      }
      if (newUpdate.start_time !== undefined) {
        _cacheData.start_time = newUpdate.start_time
      }
      if (newUpdate.end_time !== undefined) {
        _cacheData.end_time = newUpdate.end_time
      }
      if (newUpdate.remark !== undefined) {
        _cacheData.remark = newUpdate.remark
      }
      if (newUpdate.course_name !== undefined) {
        _cacheData.course_name = newUpdate.course_name
      }
      if (newUpdate.color !== undefined) {
        _cacheData.colorCode = newUpdate.color
      }
      if (newUpdate.max_student !== undefined) {
        _cacheData.max_student = newUpdate.max_student
      }
      if (newUpdate.grade !== undefined) {
        _cacheData.grade = this.disableCourseGrade ? '' : newUpdate.grade
      }
      if (newUpdate.classroom_id !== undefined) {
        if (newUpdate.classroom_id > -1) {
          const foundClassroom = this.classroomOptions.find(el => el.value === newUpdate.classroom_id)
          if (foundClassroom) {
            _cacheData.classroom = foundClassroom.text
          }
        } else {
          _cacheData.classroom = ''
        }
      }

      if (newUpdate.tutor_id_list !== undefined && this.$validate.DataValid(newUpdate.tutor_id_list, true)) {
        const tutors = this.tutorOptions.filter(el => newUpdate.tutor_id_list.includes(el.value))
        _cacheData.tutor = tutors.map(el => el.text).join(', ')
      } else if (newUpdate.tutor_id !== undefined && newUpdate.tutor_id > -1) {
        const tutor = this.tutorOptions.find(el => el.value === newUpdate.tutor_id)
        if (tutor) {
          _cacheData.tutor = tutor.text
        }
      }

      if (newUpdate.course_id !== undefined) {
        const found = this.courseOptions.find(el => el.value === newUpdate.course_id)
        if (found) {
          _cacheData.course_category_id = found.category_id
        }
      }

      return _cacheData
    },

    // -- save 課堂資訊 & 學生 attendance
    async save() {
      if (!this.permissionValid || (!this.canEdit && !this.canTakeAttendance && !this.canTutorEdit)) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['classInfoForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      // reject if attendance update to skip & unpaid lesson
      const skipFalseStudents = []
      for (let i = 0; i < this.studentTableData.length; i++) {
        if (this.studentTableData[i].attend_status === 'new_skip' && this.studentTableData[i].unpaid) {
          skipFalseStudents.push(this.studentTableData[i].class_student_name)
        }
      }
      if (skipFalseStudents.length > 0) {
        this.showAlert({
          title: 'message.disableSkipIfUnpaid',
          message: skipFalseStudents.join(', '),
          isError: true,
        })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        let attendanceChanged = false
        // ------------ payload -------------
        let payload = {
          date: this.formData.date,
          start_time: this.formData.start_time,
          end_time: this.formData.end_time,
          attachment_list: this.formData.attachment_list.map(el => {
            return { file: el.file, name: el.name }
          }),
          attendance_list: [],
          remark: this.formData.remark,
        }
        if (this.enableTutorAttendance) {
          payload['tutor_attendance'] = this.tutorTableData.map(item => {
            return { staff_id: item.id, status: item.attend_status }
          })
        }
        this.studentTableData.forEach(item => {
          let found = null
          for (let x = this.rawAttendance.length - 1; x >= 0; x--) {
            if (this.rawAttendance[x].student_id === item.id) {
              found = this.rawAttendance[x]
              break
            }
          }
          if (found) {
            let temp = JSON.parse(JSON.stringify(found))
            if (item.attend_status !== 'new_skip') {
              temp.status = item.attend_status

              if (found.status !== item.attend_status) {
                attendanceChanged = true
              }
            }
            payload['attendance_list'].push(temp)
          }
        })
        if (this.isAppMode(['DEV', 'T04'])) {
          if (this.formData.vimeo_attachment_list.length > 0) {
            payload['video_id'] = this.formData.vimeo_attachment_list[0].video_id
          } else {
            payload['video_attachment_id'] = ''
            payload['video_attachment_name'] = ''
            payload['video_attachment_url'] = ''
            payload['video_attachment_html'] = ''
          }
        }

        if (!this.canEdit) {
          let _p = {}
          if (this.canTakeAttendance) {
            _p['attendance_list'] = payload['attendance_list']
            if (payload['tutor_attendance'] !== undefined) {
              _p['tutor_attendance'] = payload['tutor_attendance']
            }
          }

          if (this.canTutorEdit) {
            _p['attachment_list'] = payload['attachment_list']
            _p['remark'] = payload['remark']
            if (payload['video_id'] !== undefined) {
              _p['video_id'] = payload['video_id']
            }
            if (payload['video_attachment_id'] !== undefined) {
              _p['video_attachment_id'] = payload['video_attachment_id']
            }
            if (payload['video_attachment_name'] !== undefined) {
              _p['video_attachment_name'] = payload['video_attachment_name']
            }
            if (payload['video_attachment_url'] !== undefined) {
              _p['video_attachment_url'] = payload['video_attachment_url']
            }
            if (payload['video_attachment_html'] !== undefined) {
              _p['video_attachment_html'] = payload['video_attachment_html']
            }
          }

          payload = _p
        }
        // --------- Enf of payload ---------

        await this.$Fetcher.UpdateLesson(this.id, payload)
        if (attendanceChanged) {
          this.$store.dispatch('addTimetableUpdateLesson', [this.id]);
        } else {
          this._updateCacheTimetableLessons([{ id: this.id, ...payload }])
        }

        const newSkips = this.studentTableData.filter(el => el.attend_status === 'new_skip')
        if (newSkips.length > 0) {
          this._handleMultiSkip(newSkips)
          return
        }
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
        this.$store.dispatch('setLoading', false)
      }
    },
    async _handleMultiSkip(newSkips) {
      try {
        await this.$Fetcher.SkipLessonByStudentIdList(
          this.id,
          newSkips.map(el => el.id),
        )
        this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
        this.$store.dispatch('setLoading', false)

        let msg = err
        if (this.$validate.DataValid(err, true)) {
          const names = err.map(sid => {
            const found = this.studentTableData.find(el => el.id === sid)
            return found ? found.class_student_name : ''
          })
          msg = this.$t('message.skipNotAllowedAsAllLessonApplied', { names: names.join(', ') })
        }

        this.showAlert({
          title: 'message.saveFail',
          message: msg,
          isError: true,
          returnLink: { reload: true },
        })
      }
    },

    // -- Delete 此課堂
    async handleDeleteThisLesson() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmToDeleteThisLesson',
        message: 'message.confirmToDeleteThisLessonMsg',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteLesson([this.id])
          this._removeCacheLessons([this.id]) // remove lesson from cache lessons
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'Timetable',
          })
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)

          if (this.$validate.DataValid(err, true) && err[0].info) {
            let msg = `${this.staticLessonInfo.course_name} (${this.staticLessonInfo.date})`
            if (err[0].students && Array.isArray(err[0].students)) {
              msg += `<br><small>${this.$t('message.paidStudentOccur', {
                students: err[0].students.join(', '),
              })}</small>`
            }
            if (err[0].info === 'not all pending') {
              this.showAlert({
                title: 'message.applyOccurFollowLessons',
                message: msg,
                isError: true,
              })
              return
            } else if (err[0].info === 'paid lesson') {
              this.showAlert({
                title: 'message.paidOccurFollowLessons',
                message: msg,
                isError: true,
              })
              return
            }
          }

          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        }
      }
    },

    // -- (確認出席狀態)
    async confirmAttendance(id) {
      if (!this.permissionValid || !this.canConfirmTutorAttendance) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        message: 'message.confirmTutorAttendance',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          let index = -1
          for (let i = 0; i < this.tutorTableData.length; i++) {
            if (this.tutorTableData[i].id === id) {
              index = i
              break
            }
          }
          const data = await this.$Fetcher.ConfirmTutorAttendance(this.id, id, this.tutorTableData[index].attend_status)
          this.tutorTableData[index].attend_status = data.status
          this.tutorTableData[index].init_attend_status = data.status
          if (data.status === 'attend') {
            this.tutorTableData[index].attend_time = data.attend_time ? data.attend_time.substring(11, 16) : ''
          } else {
            this.tutorTableData[index].attend_time = ''
          }

          this.tutorTableData[index].attend_confirm_time = data ? data.confirm_time : ''
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
        this.$store.dispatch('setLoading', false)
      }
    },

    // ============ 修改課堂 / 新增一個單一課堂 ============
    async handleEditClassSetting(type, newOpen = true) {
      if (newOpen) {
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        if (type !== 'new' && type !== 'edit') return

        this.$refs.editClassFormDialog.setInfo(type)
        this._resetClassForm()
        for (const key in this.classData) {
          if (this.staticLessonInfo[key] !== undefined) {
            this.$set(this.classData, key, this.staticLessonInfo[key])
          }
        }
        if (type === 'new') {
          if (this.$validate.DataValid(this.staticLessonInfo.school_type)) {
            if (this.staticLessonInfo.school_type === 'all') {
              this.schoolTypeOptions = [{ value: 'all', text: this.$t('lessonSchoolTypeOptions.all') }]
            } else {
              this.schoolTypeOptions = [
                {
                  value: this.staticLessonInfo.school_type,
                  text: this.$t(`lessonSchoolTypeOptions.${this.staticLessonInfo.school_type}`),
                },
                { value: 'all', text: this.$t('lessonSchoolTypeOptions.all') },
              ]
            }
          }
          this.classData.course_code = ''
          this.classData.date = ''
          this.classData.start_time = ''
          this.classData.end_time = ''
        }
        if (!this.courseOptions.length && !this.courseOptionLoading) {
          this._getCourseOptions()
        }
        if (this.classroomOptions.length < 1 && !this.classroomLoading) {
          this._getClassroomOptions()
        }
        if (this.tutorOptions.length < 1 && !this.tutorOptionsLoading) {
          this._getTutorOptions()
        }
      } else {
        this.$refs.editClassFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.editClassFormDialog.show()
      if (confirm) {
        if (type === 'new') {
          this.addSingleLessonAndSwitch()
        } else if (type === 'edit') {
          this.$refs.confirmEditLesson.show()
        } else {
          this.$refs.editClassFormDialog.hide()
        }
      }
    },
    _resetClassForm() {
      this.classData.course_id = null
      this.classData.course_name = ''
      this.classData.price = ''
      this.classData.tutor_id = ''
      this.classData.tutor_id_list = []
      this.classData.classroom_id = null
      this.classData.color = ''
      this.classData.salary_method = 'by_lesson'
      this.classData.max_student = 1
      this.classData.thumbnail_image_list = []
      this.classData.course_description = ''
      this.classData.salary_level = null
      this.classData.show_website = false
      this.classData.course_code = ''
      this.classData.date = ''
      this.classData.start_time = ''
      this.classData.end_time = ''
      this.classData.attachment_list = []
      this.classData.school_type = ''
      this.classData.t16_salary = ''
      this.classData.t16_salary_percentage = ''
      this.classData.t16_salary_per_hour = ''
      this.classData.t16_salary_type = null
      this.schoolTypeOptions = [
        { value: 'A', text: this.$t('lessonSchoolTypeOptions.A') },
        { value: 'B', text: this.$t('lessonSchoolTypeOptions.B') },
        { value: 'all', text: this.$t('lessonSchoolTypeOptions.all') },
      ]
    },
    async _getCourseOptions() {
      this.courseOptionLoading = true
      try {
        let payload = {
          join_category_data: true,
        }

        if (this.$validate.DataValid(this.staticLessonInfo.school_id)) {
          payload['center_id'] = this.staticLessonInfo.school_id
        }

        const { data } = await this.$Fetcher.GetCourses(payload)
        this.courseOptions = await this.gfSortCourseOptions(data)
      } catch {
      } finally {
        this.courseOptionLoading = false
      }
    },

    checkLessonDateValid(date) {
      if (this.$validate.DataValid(date)) {
        const holidayDates = this.holidayList.map(el => el.date)
        if (holidayDates.includes(date)) {
          return this.$t('message.isHolidayLesson')
        }
        return true
      }
      return false
    },
    onSalaryTypeChanged() {
      if (this.classData.t16_salary_type === 'percentage') {
        this.classData.salary_method = 'by_student_num'
      } else {
        this.classData.salary_method = 'by_lesson'
      }
    },
    onCourseChanged() {
      if (this.isAppMode(['T22', 'T37', 'T45', 'T49'])) {
        const found = this.courseOptions.find(el => el.value === this.classData.course_id)
        if (found) {
          this.classData.course_name = found.text
        }
      }
    },
    onClassTutorChanged(multiple = true) {
      if (
        this.isAppMode(['T16']) &&
        this.canViewSalary &&
        !multiple &&
        this.$validate.DataValid(this.classData.tutor_id) &&
        this.classData.tutor_id > -1
      ) {
        const found = this.tutorOptions.find(el => el.value === this.classData.tutor_id)
        this.classData.t16_salary_per_hour = found ? found.salary_per_hour || 0 : 0
      }
    },

    _getClassSettingPayload() {
      const selectedCourse = this.courseOptions.find(el => el.value === this.classData.course_id)
      let payload = {
        course_id: parseInt(this.classData.course_id),
        course_name: this.classData.course_name,
        tutor_id: -1,
        classroom_id: -1,
        color: this.classData.color,
        salary_method: this.classData.salary_method,
        max_student: parseInt(this.classData.max_student),
        price: parseFloat(this.classData.price),
      }
      if (selectedCourse) payload['grade'] = selectedCourse.grade

      if (this.$validate.DataValid(this.classData.classroom_id)) {
        payload['classroom_id'] = parseInt(this.classData.classroom_id)
      }

      if (this.isAppMode(['T04'])) {
        payload['school_type'] = this.classData.school_type
      } else if (this.isAppMode(['T16'])) {
        payload['t16_salary_type'] = this.classData.t16_salary_type || ''
        if (this.classData.t16_salary_type === 'percentage') {
          payload['t16_salary'] = parseFloat(this.classData.t16_salary)
          payload['t16_salary_percentage'] = parseFloat(this.classData.t16_salary_percentage)
        } else if (this.classData.t16_salary_type === 'hour') {
          payload['t16_salary_per_hour'] = parseFloat(this.classData.t16_salary_per_hour)
        }
      }

      if (!this.gDisableCourseToOnline) {
        payload['thumbnail_image'] = this.classData.thumbnail_image_list.length
          ? this.classData.thumbnail_image_list[0].file
          : ''
        payload['course_description'] = this.classData.course_description
        payload['show_website'] = this.classData.show_website
      }

      if (this.isAppMode(['T01', 'T16'])) {
        if (this.$validate.DataValid(this.classData.tutor_id)) {
          payload['tutor_id'] = parseInt(this.classData.tutor_id)
        }

        if (this.isAppMode(['T16'])) {
          payload['tutor_id_list'] = []
          payload['multi_salary_level'] = []
          payload['salary_type'] = []
          payload['salary_per_hour'] = []
          payload['salary_percentage'] = []
        }
      } else {
        payload['salary_level'] = this.classData.salary_level
        payload['salary_method'] = 'by_lesson'

        payload['tutor_id_list'] = this.classData.tutor_id_list
      }

      return payload
    },

    // === 修改課堂
    async editClassSettingSubmit(type = null) {
      try {
        // ----------- payload ------------
        const getPayload = this._getClassSettingPayload()
        let payload = {
          ...getPayload,
        }
        // 有啲CMS由單一tutor轉做multiple tutor，可能個lesson data會冇 `multi_salary_level`，所以同時save返 & delete走啲冇咗嘅tutor
        if (!this.isAppMode(['T01', 'T16']) && payload['tutor_id_list']) {
          payload['multi_salary_level'] = this.staticLessonInfo.multi_salary_level.filter(el =>
            payload['tutor_id_list'].includes(el.staff_id),
          )
          payload['salary_type'] = this.staticLessonInfo.salary_type.filter(el =>
            payload['tutor_id_list'].includes(el.staff_id),
          )
          payload['salary_per_hour'] = this.staticLessonInfo.salary_per_hour.filter(el =>
            payload['tutor_id_list'].includes(el.staff),
          )
          payload['salary_percentage'] = this.staticLessonInfo.salary_percentage.filter(el =>
            payload['tutor_id_list'].includes(el.staff),
          )
          if (this.isAppMode(['T21'])) {
            payload['salary_bonus'] = this.staticLessonInfo.salary_bonus.filter(el =>
              payload['tutor_id_list'].includes(el.staff_id),
            )
          }
        }
        // --------- End of payload ---------

        await this._submitLessonUpdate(type, payload)
        this.$refs.confirmEditLesson.hide()
        this.$refs.editClassFormDialog.hide()
        this.$store.dispatch('toggleSnack', {
          message: 'message.updateSuccess',
          type: 'success',
          refresh: true,
        })
      } catch {
        this.$refs.confirmEditLesson.hide()
        this.handleEditClassSetting('edit', false)
      }
    },
    _submitLessonUpdate(type, update) {
      return new Promise(async (resolve, reject) => {
        if (type === 'one' || type === 'all' || type === 'all_after') {
          this.$store.dispatch('setLoading', true)

          try {
            let payload = {
              ...update,
              course_code: this.staticLessonInfo.course_code,
            }
            if (type === 'all' || type === 'all_after') {
              // 如果係常規課程，先update 常規課程 setting（regular_data）
              const regularIds = []
              if (this.staticLessonInfo.regular_id > -1) {
                regularIds.push(this.staticLessonInfo.regular_id)
                for (let i = 0; i < this.otherLessonData.length; i++) {
                  if (
                    this.otherLessonData[i].regular_id > -1 &&
                    !regularIds.includes(this.otherLessonData[i].regular_id)
                  ) {
                    regularIds.push(this.otherLessonData[i].regular_id)
                  }
                }
              }
              if (regularIds.length > 0) {
                await this._updateRegularSetting(regularIds, payload)
              }

              // update 所有lesson
              if (type === 'all') {
                // 搵第一堂日期
                const allLessons = this.otherLessonData.map(el => el.date)
                allLessons.push(this.staticLessonInfo.date)
                allLessons.sort((a, b) => this.$formatter.sortDate(a, b))
                const d = this.$formatter.convertDate(allLessons[0])
                d.setDate(d.getDate() - 1)
                payload['date'] = this.$formatter.formatDate(d)
              } else {
                payload['date'] = this.staticLessonInfo.date
              }
              await this.$Fetcher.UpdateLessonSetting(this.id, payload)
              this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
            } else {
              await this.$Fetcher.UpdateLesson(this.id, payload)
              this._updateCacheTimetableLessons([{ id: this.id, ...payload }])
            }

            this.$store.dispatch('setLoading', false)
            resolve(true)
          } catch (err) {
            this.$common.error(err)
            this.showAlert({
              title: 'message.updateFail',
              message: err,
              isError: true,
            })
            this.$store.dispatch('setLoading', false)
            reject(err)
          }
        } else {
          reject(false)
        }
      })
    },
    async _updateRegularSetting(regularIds, payload, count = 0) {
      if (count < regularIds.length) {
        try {
          await this.$Fetcher.UpdateRegularSetting(regularIds[count], payload)
        } catch (err) {
          this.$common.error(err)
        } finally {
          count += 1
          await this._updateRegularSetting(regularIds, payload, count)
        }
      }
    },

    // ==== 新增一個單一課堂
    isAddNewSingle() {
      if (this.$refs && this.$refs.editClassFormDialog) {
        const getType = this.$refs.editClassFormDialog.getInfo()
        return getType === 'new'
      }

      return false
    },
    // (確認)
    async addSingleLessonAndSwitch() {
      const confirm = await this.confirmRef.show({
        title: 'message.confirmAddSingleLesson',
        message: 'message.confirmAddSingleLessonMsg',
      })
      if (confirm) {
        // create class
        const checkSchool = this.gfCheckSchoolSelected()
        if (!checkSchool) {
          this.handleEditClassSetting('new', false)
          return
        }

        try {
          const getPayload = this._getClassSettingPayload()
          let payload = {
            ...getPayload,
            course_code: this.classData.course_code.trim(),
            school_id: this.$validate.DataValid(this.staticLessonInfo.school_id) ? this.staticLessonInfo.school_id : -1,
            single_date: this.classData.date,
            lesson_type: 'single',
            start_time: this.classData.start_time,
            end_time: this.classData.end_time,
          }

          const data = await this.$Fetcher.NewSingleDateLesson(payload)
          this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          setTimeout(() => {
            this._switchToNewLesson(data.id)
          }, 500)
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
          this.handleEditClassSetting('new', false)
        }
      } else {
        this.handleEditClassSetting('new', false)
      }
    },
    async _switchToNewLesson(newLessonId) {
      try {
        const withPackage = this.staticLessonInfo.package_used_student_id_list.includes(this.changeLessonStudentId)
        await this.$Fetcher.SwitchLesson(this.changeLessonStudentId, this.id, newLessonId, withPackage)
        this.$store.dispatch('addTimetableUpdateLesson', [this.id, newLessonId])
        this.$store.dispatch('toggleSnack', {
          message: 'message.switchLessonSuccess',
          type: 'success',
        })
        this.$refs.editClassFormDialog.hide()
        this.$refs.changeLessonDialog.hide()
        this.$refs.changeLessonTimetable.hide()
        this.getStudentAttendance()
        this.getOtherLessons()
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.newLessonSuccessButSwitchLessonFail',
          message: err,
          isError: true,
        })
        this.handleEditClassSetting('new', false)
      }
    },

    // ============== 跳堂 ==============
    async skipLesson(studentId) {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      // reject if unpaid
      const found = this.studentTableData.find(el => el.id === studentId)
      if (found.unpaid) {
        this.showAlert({
          title: 'message.operationalError',
          message: 'message.disableSkipIfUnpaid',
          isError: true,
        })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const check = await this.$Fetcher.SkipLessonPre(this.id, studentId)
        this.$store.dispatch('setLoading', false)

        let skipToLesson = null
        if (check !== null) {
          skipToLesson = `${check.course_name} ${check.date} (${this.$d(
            this.$formatter.convertDate(check.date),
            'weekdayShort',
          )}) ${check.start_time} - ${check.end_time}`
        }

        const confirm = await this.confirmRef.show({
          title: 'message.confirmToSkipLesson',
          message: this.$validate.DataValid(skipToLesson)
            ? this.$t('message.confirmToSkipLessonWithLessonMsg', { lesson: skipToLesson })
            : 'message.confirmToSkipLessonMsg',
        })
        if (confirm) {
          this.$store.dispatch('setLoading', true)
          await this.$Fetcher.SkipLesson(this.id, studentId)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
          this.getOtherLessons()
        }
      } catch (err) {
        this.$store.dispatch('setLoading', false)
        if (err === 'to missing' && this.staticLessonInfo.package_used_student_id_list.includes(studentId)) {
          this._handleConfirmAddMoreLesson(studentId)
        } else {
          let msg = err
          if (err === 'to missing') {
            msg = 'message.targetCourseNotEnoughLesson'
          }
          this.showAlert({
            title: 'message.saveFail',
            message: msg,
            isError: true,
          })
        }
      }
    },
    async _handleConfirmAddMoreLesson(studentId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const confirm = await this.confirmRef.show({
        title: 'message.targetCourseNotEnoughLesson',
        message: 'message.askConfirmToAddLessonForSkip',
        confirmBtnText: 'confirmAddLessonAndSkip',
        cancelBtnText: 'continueSkip',
      })
      if (confirm) {
        // 加一堂 -> skip_lesson
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.ExtendRegularLesson(this.staticLessonInfo.regular_id, { days: 1 })
          await this.$Fetcher.SkipLesson(this.id, studentId)
          this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
        } catch (err) {
          this.$common.error(err)

          let msg = err
          if (err === 'to missing') {
            msg = 'message.targetCourseNotEnoughLesson'
          }
          this.showAlert({
            title: 'message.saveFail',
            message: msg,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      } else {
        // // 唔加 -> update_lesson student attendance to "skip"
        // const attendanceList = this.rawAttendance.map(item => {
        //   let temp = JSON.parse(JSON.stringify(item))
        //   if (item.student_id === studentId) {
        //     temp.status = 'skip'
        //   }
        //   return temp
        // })

        // try {
        //   await this.$Fetcher.UpdateLesson(this.id, { attendance_list: attendanceList })
        //   this.$store.dispatch('addTimetableUpdateLesson', [this.id])
        //   this.$store.dispatch('setLoading', false)
        //   this.$store.dispatch('toggleSnack', {
        //     message: 'message.saveSuccess',
        //     type: 'success',
        //   })
        //   this.getStudentAttendance()
        // } catch (err) {
        //   this.$common.error(err)
        //   this.showAlert({
        //     title: 'message.saveFail',
        //     message: err,
        //     isError: true,
        //   })
        //   this.$store.dispatch('setLoading', false)
        // }
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DropLesson(this.id, studentId)
          this.$store.dispatch('addTimetableUpdateLesson', [this.id])
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ======== 轉堂/轉堂(單一課堂) ========
    async openChangeLesson(type, student_id) {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.startSearching = false
      this.changeLessonFilter.mode = 'calendar'
      this.changeLessonFilter.type = type
      this.changeLessonStudentId = student_id
      this.changeLessonFilter.grade = ''
      this.changeLessonFilter.keyword = this.staticLessonInfo.course_name
      this.changeLessonFilter.dateRange = []
      this.changeLessonFilter.date = ''
      this.changeLessonFilter.tutor = ''
      this.isSearching = true
      this.searchTableOptions.tablePage = 1
      this.searchTableData = []
      this.searchTableTotal = 0
      this.datePickerDisplay = this.$formatter.formatDate()
      const foundThisCourseName = this.allCourseNameOptions.find(el => el.value === this.staticLessonInfo.course_name)
      if (!foundThisCourseName) {
        this.allCourseNameOptions.push({
          value: this.staticLessonInfo.course_name,
          text: this.staticLessonInfo.course_name,
          lesson_type: [this.staticLessonInfo.lesson_type],
        })
      }
      this._getCourseNameOptions()
      this.$refs.changeLessonDialog.show('search_lesson')

      // find student applied lesson
      try {
        const { data } = await this.$Fetcher.GetLessons({ filter_item: [{ key: 'student_id', value: student_id }] })
        const appliedLessons = data.filter(el => el.student_ids.includes(student_id))
        this.appliedLessonIds = appliedLessons.map(el => el.id)
      } catch (err) {
        this.$common.error(err)
        if (err === 'abort') {
          return
        }
      }

      this.startSearching = true
      this._getCourseNameOption()
      this.searchLesson()
    },
    async _getCourseNameOption() {
      if (!this.courseNameSearching && (this.allCourseNameOptions.length < 1 || this.courseNameOptionsInit)) {
        this.courseNameSearching = true
        this.allCourseNameOptions = await this.$Fetcher.GetAllCourseNames(this.staticLessonInfo.school_id)
        this.courseNameOptionsInit = false
        this.courseNameSearching = false
      }
      this._getCourseNameOptions()
    },
    _getCourseNameOptions() {
      if (this.changeLessonFilter.type === 'all') {
        this.courseNameOptions = this.allCourseNameOptions.filter(el => el.lesson_type.includes('regular'))
      }
      this.courseNameOptions = this.allCourseNameOptions
    },

    async searchLesson() {
      let controllerName = 'search_lesson'
      const calendarOpen = this.$refs.changeLessonTimetable.isOpen()
      if (calendarOpen) {
        controllerName = 'calendar_lesson'
      }

      this.isSearching = true

      // ------------------- payload ------------------
      let payload = {
        controller_name: controllerName,
        center_id: this.staticLessonInfo.school_id,
        filter_item: [],
      }
      if (this.$validate.DataValid(this.changeLessonFilter.tutor) && this.changeLessonFilter.tutor > -1) {
        payload['filter_item'].push({ key: 'staff_id', value: this.changeLessonFilter.tutor })
      }
      if (
        this.$validate.DataValid(this.changeLessonFilter.keywordType) &&
        this.$validate.DataValid(this.changeLessonFilter.keyword)
      ) {
        payload['filter_item'].push({
          key: this.changeLessonFilter.keywordType,
          value: this.changeLessonFilter.keyword,
        })
      }
      if (this.$validate.DataValid(this.changeLessonFilter.grade) && this.changeLessonFilter.grade !== 'all') {
        payload['filter_item'].push({ key: 'grade', value: this.changeLessonFilter.grade })
      }
      if (this.changeLessonFilter.type === 'all') {
        payload.filter_item.push({ key: 'lesson_type', value: 'regular' })
      }

      if (this.changeLessonFilter.mode === 'calendar') {
        // 日曆Mode
        if (this.$validate.DataValid(this.changeLessonFilter.date)) {
          // 如果揀咗日期 -> list mode
          payload['filter_limit'] = this.searchTableOptions.tableLimit
          payload['filter_page'] = this.searchTableOptions.tablePage - 1
          payload['join_tutor_data'] = true
          payload['filter_item'].push({ key: 'date', value: this.changeLessonFilter.date })
        } else {
          // 咩都冇揀，用display個月
          const today = this.$formatter.convertDate()
          let displayYear = today.getFullYear()
          let displayMonth = today.getMonth() + 1
          if (/^\d{4}-\d{2}(-\d{2})?$/.test(this.datePickerDisplay)) {
            displayYear = parseInt(this.datePickerDisplay.substring(0, 4))
            displayMonth = parseInt(this.datePickerDisplay.substring(5, 7))
          }

          const startDate = this.$formatter.convertDate(`${displayYear}-${this.$formatter.pad(displayMonth)}-01`)
          payload.filter_item.push({ key: 'start_date', value: this.$formatter.formatDate(startDate) })
          const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
          payload.filter_item.push({ key: 'end_date', value: this.$formatter.formatDate(endDate) })
        }
      } else if (this.changeLessonFilter.mode === 'timetable') {
        // 課程表Mode
        payload['join_tutor_data'] = true
        if (this.changeLessonFilter.timetableType === 'day' || this.changeLessonFilter.timetableType === 'week') {
          if (this.changeLessonFilter.dateRange[0]) {
            if (
              this.changeLessonFilter.dateRange[1] &&
              this.changeLessonFilter.dateRange[1] !== this.changeLessonFilter.dateRange[0]
            ) {
              payload['filter_item'].push({ key: 'start_date', value: this.changeLessonFilter.dateRange[0] })
              payload['filter_item'].push({ key: 'end_date', value: this.changeLessonFilter.dateRange[1] })
            } else {
              payload['filter_item'].push({ key: 'date', value: this.changeLessonFilter.dateRange[0] })
            }
          }
        } else {
          const today = this.$formatter.convertDate()
          let displayYear = today.getFullYear()
          let displayMonth = today.getMonth() + 1
          if (/^\d{4}-\d{2}(-\d{2})?$/.test(this.datePickerDisplay)) {
            displayYear = parseInt(this.datePickerDisplay.substring(0, 4))
            displayMonth = parseInt(this.datePickerDisplay.substring(5, 7))
          }

          const startDate = this.$formatter.convertDate(`${displayYear}-${this.$formatter.pad(displayMonth)}-01`)
          payload.filter_item.push({ key: 'start_date', value: this.$formatter.formatDate(startDate) })
          const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
          payload.filter_item.push({ key: 'end_date', value: this.$formatter.formatDate(endDate) })
        }
      } else {
        // 列表Mode
        payload['filter_limit'] = this.searchTableOptions.tableLimit
        payload['filter_page'] = this.searchTableOptions.tablePage - 1
        payload['join_tutor_data'] = true

        if (this.changeLessonFilter.type === 'single' && this.$validate.DataValid(this.changeLessonFilter.date)) {
          payload['filter_item'].push({ key: 'date', value: this.changeLessonFilter.date })
        } else if (
          this.changeLessonFilter.type === 'all' &&
          this.$validate.DataValid(this.changeLessonFilter.dateRange) &&
          this.changeLessonFilter.dateRange.length > 0
        ) {
          if (this.changeLessonFilter.dateRange[0]) {
            if (
              this.changeLessonFilter.dateRange[1] &&
              this.changeLessonFilter.dateRange[1] !== this.changeLessonFilter.dateRange[0]
            ) {
              payload['filter_item'].push({ key: 'start_date', value: this.changeLessonFilter.dateRange[0] })
              payload['filter_item'].push({ key: 'end_date', value: this.changeLessonFilter.dateRange[1] })
            } else {
              payload['filter_item'].push({ key: 'date', value: this.changeLessonFilter.dateRange[0] })
            }
          }
        } else {
          const current_month = this.$formatter.convertDate()
          current_month.setDate(1)
          payload['filter_item'].push({ key: 'start_date', value: this.$formatter.formatDate(current_month) })
        }
      }

      // For T04: School A lesson can switch to School A/All type lesson. All type lesson only can switch to All type.
      if (this.isAppMode(['T04']) && this.staticLessonInfo.school_type) {
        payload.filter_item.push({ key: 'school_type', value: this.staticLessonInfo.school_type })
      }
      // --------------- End of payload ---------------

      try {
        const { data, total } = await this.$Fetcher.GetLessons(payload)
        this.searchTableTotal = total
        this.searchTableData = data.map(el => {
          return {
            id: el.id, // lesson id
            date: el.date,
            tutor: el.tutor_data_list.map(t => t.name).join(', '),
            current_student_num: el.current_student_num,
            max_student: el.max_student,
            color: '#eeeeee',
            colorCode: el.color,
            grade: el.grade,
            course_name: el.course_name,
            start_time: el.start_time,
            end_time: el.end_time,
            classroom: this.$validate.DataValid(el.classroom_data) ? el.classroom_data.name : '',
            remark: el.remark,
            lesson_type: el.lesson_type,
            course_id: el.course_id,
            course_code: el.course_code,
            applied: this.$validate.DataValid(this.appliedLessonIds) && this.appliedLessonIds.includes(el.id),
            same: this.changeLessonFilter.type === 'all' && el.course_code === this.staticLessonInfo.course_code,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.searchTableData = []
        if (this.$validate.DataValid(payload['filter_page']) && payload['filter_page'] === 0) {
          this.searchTableTotal = 0
        }
      } finally {
        this.isSearching = false
      }
    },
    onChangeLessonFilterChange() {
      const calendarOpen = this.$refs.changeLessonTimetable.isOpen()
      if (this.changeLessonFilter.mode === 'timetable' && !calendarOpen) return
      this.searchTableOptions.tablePage = 1
      this.searchTableTotal = 0
      this.searchLesson()
    },
    // -- 檢視方式
    onChangeLessonModeChanged(mode, force = false) {
      if (!force && (this.changeLessonFilter.mode === mode || this.isSearching || this.$store.getters.isLoading)) {
        return
      }

      this.changeLessonFilter.mode = mode
      this.changeLessonFilter.dateRange = []
      if (this.changeLessonFilter.type === 'all' || mode === 'calendar') {
        this.changeLessonFilter.date = ''
      }

      if (mode === 'timetable') {
        if (this.changeLessonFilter.date) {
          this.$refs.timetable.setCurrentValue(this.changeLessonFilter.date)
          this.changeLessonFilter.dateRange = [this.changeLessonFilter.date]
          this.$refs.timetable.setCalendarType('day')
          this.changeLessonFilter.timetableType = 'day'
        } else {
          if (/^\d{4}-\d{2}(-\d{2})?$/.test(this.datePickerDisplay)) {
            this.$refs.timetable.setCurrentValue(`${this.datePickerDisplay.substring(0, 7)}-01`)
          } else {
            this.$refs.timetable.setCurrentValue()
          }
          this.changeLessonFilter.timetableType = 'month'
          this.$refs.timetable.setCalendarType('month')
        }
        const dateList = this.$refs.timetable.getDatesList()
        this.$refs.timetable.setDateList(dateList)
        this.$refs.changeLessonTimetable.show('calendar_lesson')
      }

      this.onChangeLessonFilterChange()
    },
    formatCalendarWeekday(event) {
      return `${this.$i18n.locale !== 'en' ? '週' : ''}${this.$d(this.$formatter.convertDate(event), 'weekdayShort')}`
    },
    checkDateCanSelect(event) {
      const dates = this.searchTableData.map(el => el.date)
      return dates.includes(event)
    },
    onDatePickerChange() {
      this.searchLesson()
    },
    backToCalendar() {
      this.$XHR.abort('search_lesson')
      this.changeLessonFilter.date = ''
      this.isSearching = true
      this.$XHR.restart('search_lesson')
      this.searchLesson()
    },
    onTimetableChange(dates = []) {
      this.changeLessonFilter.dateRange = dates
      if (dates.length) {
        if (this.changeLessonFilter.timetableType === 'month') {
          this.changeLessonFilter.dateRange = []
          this.datePickerDisplay = dates[0]
        }
      }
      this.onChangeLessonFilterChange()
    },
    _displayCalendarWeekday(d) {
      return this.$d(this.$formatter.convertDate(d.date), 'weekday')
    },
    _displayCalendarDay(d) {
      const date = this.$formatter.convertDate(d.date)
      return date.getDate()
    },
    onTimetableDateChange() {
      if (!this.$validate.DataValid(this.changeLessonFilter.date)) {
        this.$refs.timetable.setCurrentValue()
        const todayStr = this.$refs.timetable.getTodayStr()
        this.changeLessonFilter.dateRange = [todayStr]
      } else {
        this.$refs.timetable.setCurrentValue(this.changeLessonFilter.date)
        this.changeLessonFilter.dateRange = [this.changeLessonFilter.date]
      }

      this.$refs.timetable.setCalendarType('day')
      this.changeLessonFilter.timetableType = 'day'
      const dateList = this.$refs.timetable.getDatesList()
      this.$refs.timetable.setDateList(dateList)
      this.onChangeLessonFilterChange()
    },

    // (確認)
    async handleChangeLesson(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (this.appliedLessonIds.includes(lesson_id)) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.lessonRepeat',
          type: 'error',
        })
        return
      }

      const targetLesson = this.searchTableData.find(el => el.id === lesson_id)
      this.$common.logData(targetLesson, '轉堂')
      if (this.$validate.DataValid(targetLesson)) {
        if (targetLesson.same) return

        let confirmObj = {}
        if (targetLesson.max_student > -1 && targetLesson.current_student_num >= targetLesson.max_student) {
          // if(this.isAppMode(['T75'])){
          //   this.$store.dispatch('toggleSnack', {
          //     message: 'message.reachedUpperLimit',
          //     type: 'error',
          //   })
          //   return
          // }else{
            confirmObj = {
              enableShowRemindCheckbox: true,
              key: 'exceedStudent',
              title: 'message.confirmToSwitchLesson',
              message: 'message.reachedUpperLimitConfirmSwitch',
            }
          // }
        } else {
          confirmObj = {
            enableShowRemindCheckbox: true,
            key: 'changeLesson',
            title: 'message.confirmToSwitchLesson',
            message: 'message.confirmToSwitchLessonMsg',
          }
        }
        const confirm = await this.confirmRef.show(confirmObj)
        if (!confirm) return

        this.$store.dispatch('setLoading', true)

        try {
          const withPackage = this.staticLessonInfo.package_used_student_id_list.includes(this.changeLessonStudentId)
          if (this.changeLessonFilter.type === 'all') {
            await this.$Fetcher.SwitchCourse(
              this.changeLessonStudentId,
              this.staticLessonInfo.course_code,
              targetLesson.course_code,
              this.staticLessonInfo.date,
              targetLesson.date,
              withPackage,
            )
            this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          } else if (this.changeLessonFilter.type === 'single') {
            await this.$Fetcher.SwitchLesson(this.changeLessonStudentId, this.id, targetLesson.id, withPackage)
            this.$store.dispatch('addTimetableUpdateLesson', [this.id, targetLesson.id])
          }

          this.$store.dispatch('toggleSnack', {
            message: 'message.switchLessonSuccess',
            type: 'success',
          })
          this.$refs.changeLessonDialog.hide()
          this.$refs.changeLessonTimetable.hide()
          this.getStudentAttendance()
          this.getOtherLessons()
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.switchLessonFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      } else {
        this.$refs.changeLessonDialog.hide()
        this.$refs.changeLessonTimetable.hide()
      }
    },

    // ============== 退課 ==============
    async dropCourse(studentId) {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmToDropCourse',
        message: 'message.confirmToDropCourseMsg',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DropCourse(studentId, this.staticLessonInfo.course_code, this.staticLessonInfo.date)
          this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          this.$store.dispatch('toggleSnack', {
            message: 'message.dropCourseSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
          this.getOtherLessons()
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.dropCourseFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ========= 退課（單一課堂） =========
    async dropLesson(studentId) {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmToDropLesson',
        message: 'message.confirmToDropLessonMsg',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DropLesson(this.id, studentId)
          this.$store.dispatch('addTimetableUpdateLesson', [this.id])
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ============ 匯出報表 =============
    async exportAttendance() {
      if (this.exportLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.exportLoading = true

      try {
        const payload = await this._getOtherLessonsPayload()
        const { data } = await this.$Fetcher.GetLessons({
          join_student_data: true,
          ...payload,
        })
        data.sort((a, b) => this.$formatter.sortDate(a.date, b.date))

        this.$common.logData(data, '匯出報表')

        let header = {
          student_name: '',
        }

        data.forEach(el => {
          const dateString = `${el.date.substring(8, 10)}/${el.date.substring(5, 7)}/${el.date.substring(0, 4)}`
          header[el.date] = dateString
        })

        const students = []
        data.forEach(el => {
          el.all_attendance_list.forEach(student => {
            const existed = students.find(e => e.id === student.student_id)
            if (!existed) {
              students.push({
                id: student.student_id,
                name: student.student_name,
              })
            }
          })
        })

        const exportData = students.map(el => {
          let obj = {}
          for (const key in header) {
            if (key === 'student_name') {
              obj['student_name'] = el.name
            } else {
              let status = ''
              const targetLesson = data.find(item => item.date === key)
              if (targetLesson) {
                const targetAttendance = targetLesson.all_attendance_list.find(e => e.student_id === el.id)
                if (targetAttendance) {
                  switch (targetAttendance.status) {
                    case 'attend':
                      status = 'Y'
                      break
                    case 'absent':
                      status = 'Absent'
                      break
                    case 'drop':
                      status = 'Drop'
                      break
                    case 'swap':
                      status = 'Swap'
                      break
                    case 'reschedule':
                      status = 'Reschedule'
                      break
                    case 'skip':
                      status = 'Skip'
                      break
                    case 'await':
                    case 'sick_leave':
                      status = 'Leave/Pending'
                      break
                  }
                } else if (targetLesson.dropped_student_ids.includes(el.id)) {
                  status = 'Drop'
                }
              }
              obj[key] = status
            }
          }

          return obj
        })

        this.exportExcel(
          header,
          exportData,
          this.$t('attendStatus'),
          `${this.staticLessonInfo.course_name}_attendance.xlsx`,
        )
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.$store.dispatch('toggleSnack', {
            message: 'message.exportFail',
            type: 'error',
          })
        }
      } finally {
        this.exportLoading = false
      }
    },

    // ========== 課程其他課堂 ===========
    async getOtherLessons() {
      this.otherLessonTableLoading = true
      try {
        const payload = await this._getOtherLessonsPayload()
        const { data } = await this.$Fetcher.GetLessons(payload)
        this.otherLessonData = data.filter(el => el.id !== this.id)
        const getUser = this.gfGetCurrentUserData()
        this.otherLessonTableData = this.otherLessonData.map(el => {
          let canView = true
          if (this.gTutorViewOwnLessonOnly && this.userType === 'tutor' && !el.tutor_id_list.includes(getUser.id)) {
            canView = false
          }
          return {
            id: el.id,
            course_name: el.course_name,
            weekday: this.$formatter.getDay(el.date),
            date: el.date,
            grade: el.grade,
            start_time: el.start_time,
            end_time: el.end_time,
            current_student_num: el.current_student_num,
            max_student: el.max_student,
            tutor_id: el.tutor_id,
            tutor_id_list: el.tutor_id_list,
            classroom_id: el.classroom_id,
            regular_id: el.regular_id,
            multi_salary_level: el.multi_salary_level,
            salary_type: el.salary_type,
            salary_per_hour: el.salary_per_hour,
            salary_percentage: el.salary_percentage,
            salary_bonus: el.salary_bonus,
            canView: canView,
          }
        })
        this.$common.logData(this.otherLessonTableData, '課程其他課堂')

        if (this.otherLessonTableData.length > 0) {
          const d = this.$formatter.convertDate(this.otherLessonTableData[this.otherLessonTableData.length - 1].date)
          d.setDate(d.getDate() + 1)
          this.lastLessonDate = this.$formatter.formatDate(d)
        }
      } catch (err) {
        this.$common.error(err)
        this.otherLessonData = []
        this.otherLessonTableData = []
        this.otherLessonTableLoading = false
        if (err === 'abort') {
          return false
        }
      }
      this.otherLessonTableLoading = false
      return true
    },
    _getOtherLessonsPayload() {
      return {
        center_id: this.staticLessonInfo.school_id,
        filter_item: [
          { key: 'course_code', value: this.staticLessonInfo.course_code },
          { key: 'course_id', value: this.staticLessonInfo.course_id },
        ],
      }
    },

    async handleSelectActionChange(action) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (
        !this.$validate.DataValid(this.otherLessonTableData, true) ||
        !this.$validate.DataValid(this.otherLessonSelectedRow, true)
      ) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.atLeastOneLesson',
          type: 'error',
        })
        return
      }

      if (action === 'edit') {
        this.handleEditOtherLesson()
      } else if (action === 'delete') {
        this.handDeleteLesson()
      }
    },

    // -- Edit 其他課堂
    async handleEditOtherLesson(id = null, newOpen = true) {
      if (newOpen) {
        if (!this.$validate.DataValid(id) && !this.$validate.DataValid(this.otherLessonSelectedRow)) {
          return
        }
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        this.$refs.editFormDialog.setInfo(id)
        this.editFormData.date = ''
        this.editFormData.start_time = ''
        this.editFormData.end_time = ''
        this.editFormData.tutor_id = ''
        this.editFormData.tutor_id_list = []
        this.editFormData.classroom_id = null
        await this.$refs.editFormDialog.resetForm()
        if (this.$validate.DataValid(id)) {
          this.editIsRequired = true
          const target = this.otherLessonTableData.find(el => el.id === id)
          if (target) {
            const dupTarget = JSON.parse(JSON.stringify(target))
            this.editFormData.date = dupTarget.date
            this.editFormData.start_time = dupTarget.start_time
            this.editFormData.end_time = dupTarget.end_time
            this.editFormData.tutor_id = dupTarget.tutor_id
            this.editFormData.tutor_id_list = dupTarget.tutor_id_list
            this.editFormData.end_time = dupTarget.end_time
            this.editFormData.classroom_id = dupTarget.classroom_id
          }
        } else {
          this.editIsRequired = false
        }

        if (this.classroomOptions.length < 1 && !this.classroomLoading) {
          this._getClassroomOptions()
        }
        if (this.tutorOptions.length < 1 && !this.tutorOptionsLoading) {
          this._getTutorOptions()
        }
      } else {
        this.$refs.editFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.editFormDialog.show()
      if (confirm) {
        const confirmEdit = await this.confirmRef.show({
          title: 'message.confirmToEditSelectedLesson',
          message: 'message.confirmToEditSelectedLessonMsg',
          enableShowRemindCheckbox: true,
          key: 'editOtherClass',
        })
        if (confirmEdit) {
          const updateList = []
          let lessonIds = []
          if (this.$validate.DataValid(id)) {
            lessonIds = [id]
          } else if (this.$validate.DataValid(this.otherLessonSelectedRow)) {
            lessonIds = this.otherLessonSelectedRow.map(el => el.id)
          }
          for (let i = 0; i < lessonIds.length; i++) {
            const found = this.otherLessonTableData.find(el => el.id === lessonIds[i])
            if (found) {
              let obj = {
                id: found.id,
                start_time: found.start_time,
                end_time: found.end_time,
              }
              if (this.$validate.DataValid(id) && this.editFormData.date) {
                obj['date'] = this.editFormData.date
              }

              if (
                this.$validate.DataValid(this.editFormData.start_time) &&
                this.$validate.DataValid(this.editFormData.end_time)
              ) {
                obj['start_time'] = this.editFormData.start_time
                obj['end_time'] = this.editFormData.end_time
              }

              if (this.isAppMode(['T01', 'T16'])) {
                if (this.$validate.DataValid(this.editFormData.tutor_id) && this.editFormData.tutor_id > -1) {
                  obj['tutor_id'] = this.editFormData.tutor_id
                } else if (this.$validate.DataValid(id)) {
                  obj['tutor_id'] = -1
                }
              } else {
                let tutorList = []
                if (
                  this.$validate.DataValid(this.editFormData.tutor_id_list) &&
                  this.editFormData.tutor_id_list.length > 0
                ) {
                  obj['tutor_id'] = -1
                  obj['tutor_id_list'] = this.editFormData.tutor_id_list
                  tutorList = this.editFormData.tutor_id_list
                } else if (this.$validate.DataValid(id)) {
                  obj['tutor_id'] = -1
                  obj['tutor_id_list'] = []
                }
                if (tutorList.length > 0) {
                  obj['multi_salary_level'] = found.multi_salary_level.filter(el => tutorList.includes(el.staff_id))
                  obj['salary_type'] = found.salary_type.filter(el => tutorList.includes(el.staff_id))
                  obj['salary_per_hour'] = found.salary_per_hour.filter(el => tutorList.includes(el.staff))
                  obj['salary_percentage'] = found.salary_percentage.filter(el => tutorList.includes(el.staff))
                  if (this.isAppMode(['T21'])) {
                    obj['salary_bonus'] = found.salary_bonus.filter(el => tutorList.includes(el.staff_id))
                  }
                } else if (this.$validate.DataValid(id)) {
                  obj['multi_salary_level'] = []
                  obj['salary_type'] = []
                  obj['salary_per_hour'] = []
                  obj['salary_percentage'] = []
                  if (this.isAppMode(['T21'])) {
                    obj['salary_bonus'] = []
                  }
                }
              }

              if (this.$validate.DataValid(this.editFormData.classroom_id) && this.editFormData.classroom_id > -1) {
                obj['classroom_id'] = this.editFormData.classroom_id
              } else if (this.$validate.DataValid(id)) {
                obj['classroom_id'] = -1
              }

              updateList.push(obj)
            }
          }
          this.$common.logData(updateList, 'Edit 其他課堂')

          if (updateList.length > 0) {
            const errors = await this._updateOtherLessons(updateList)
            this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
            if (errors.length) {
              const errorLessons = []
              errors.forEach(id => {
                const found = this.otherLessonData.find(el => el.id === id)
                if (found) {
                  errorLessons.push(`${found.course_name} (${found.date})`)
                }
              })

              this.showAlert({
                title: 'message.errorOccurFollowLessons',
                message: errorLessons.join('<br>'),
                isError: true,
              })
            } else {
              this.$store.dispatch('toggleSnack', {
                message: 'message.saveSuccess',
                type: 'success',
              })
            }
            this.getOtherLessons()
          }

          this.otherLessonSelectedRow = []
          this.$store.dispatch('setLoading', false)
          this.$refs.editFormDialog.hide()
        } else {
          this.handleEditOtherLesson(id, false)
        }
      }
    },
    isSingleEditLesson() {
      if (this.$refs && this.$refs.editFormDialog) {
        const id = this.$refs.editFormDialog.getInfo()
        return this.$validate.DataValid(id)
      }

      return false
    },
    async _updateOtherLessons(list, count = 0, errorList = []) {
      if (count < list.length) {
        try {
          let payload = {
            start_time: list[count].start_time,
            end_time: list[count].end_time,
          }
          if (list[count].date) payload['date'] = list[count].date
          if (list[count].tutor_id) payload['tutor_id'] = list[count].tutor_id
          if (list[count].tutor_id_list) payload['tutor_id_list'] = list[count].tutor_id_list
          if (list[count].multi_salary_level) payload['multi_salary_level'] = list[count].multi_salary_level
          if (list[count].salary_type) payload['salary_type'] = list[count].salary_type
          if (list[count].salary_per_hour) payload['salary_per_hour'] = list[count].salary_per_hour
          if (list[count].salary_percentage) payload['salary_percentage'] = list[count].salary_percentage
          if (list[count].salary_bonus) payload['salary_bonus'] = list[count].salary_bonus
          if (list[count].classroom_id) payload['classroom_id'] = list[count].classroom_id
          await this.$Fetcher.UpdateLesson(list[count].id, payload)
        } catch (err) {
          this.$common.error(err)
          errorList.push(list[count].id)
        } finally {
          count += 1
          return this._updateOtherLessons(list, count, errorList)
        }
      } else {
        return errorList
      }
    },

    // -- Delete 其他課堂
    async handDeleteLesson(id) {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmToDeleteSelectedLesson',
        message: 'message.confirmToDeleteSelectedLessonMsg',
      })
      if (confirm) {
        const deleteIds = []
        if (this.$validate.DataValid(id)) {
          deleteIds.push(parseInt(id))
        } else {
          this.otherLessonSelectedRow.forEach(el => {
            deleteIds.push(el.id)
          })
        }

        this.$common.logData(deleteIds, 'Delete 其他課堂')
        if (deleteIds.length > 0) {
          this.$store.dispatch('setLoading', true)

          try {
            await this.$Fetcher.DeleteLesson(deleteIds)
            this.$store.dispatch('setTimetableCache')
            this.$store.dispatch('toggleSnack', {
              message: 'message.deleteSuccess',
              type: 'success',
            })
          } catch (err) {
            this.$common.error(err)
            if (Array.isArray(err)) {
              const infoLessons = []
              err.forEach(item => {
                const found = this.otherLessonData.find(el => el.id === item.lesson)
                let msg = ''
                if (found) {
                  msg += `${found.course_name} (${found.date})`
                }

                if (this.$validate.DataValid(item.students, true)) {
                  msg += `<br><small>${this.$t('message.paidStudentOccur', {
                    students: item.students.join(', '),
                  })}</small>`
                }

                infoLessons.push(msg)
              })
              this.showAlert({
                title: 'message.applyOccurFollowLessons',
                message: infoLessons.join('<br><br>'),
                isError: true,
              })
            } else {
              this.showAlert({
                title: 'message.deleteFail',
                message: err,
                isError: true,
              })
            }
          } finally {
            this.$store.dispatch('setLoading', false)
            await this.getOtherLessons()
            const otherLessonIds = this.otherLessonTableData.map(el => el.id)
            this.otherLessonSelectedRow = this.otherLessonSelectedRow.filter(el => otherLessonIds.includes(el.id))
          }
        }
      }
    },

    // -- 新增其他課堂
    async handleAddOtherLesson(newOpen = true) {
      if (newOpen) {
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        this.addOtherLessonValue = ''
        this.addOtherLessonType = 'lesson_count'
        this.addOtherLessonCustom.date = ''
        this.addOtherLessonCustom.start_time = ''
        this.addOtherLessonCustom.end_time = ''
      } else {
        this.$refs.addLessonFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.addLessonFormDialog.show()
      if (confirm) {
        try {
          // ----------- payload -----------
          let payload = {}
          if (this.addOtherLessonType === 'end_date') {
            payload['end_date'] = this.addOtherLessonValue
          } else if (this.addOtherLessonType === 'custom') {
            payload['date'] = this.addOtherLessonCustom.date
            payload['start_time'] = this.addOtherLessonCustom.start_time
            payload['end_time'] = this.addOtherLessonCustom.end_time
          } else {
            payload['days'] = parseInt(this.addOtherLessonValue)
          }
          // ----------- End of payload -----------

          await this.$Fetcher.ExtendRegularLesson(this.staticLessonInfo.regular_id, payload)
          this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          this.$refs.addLessonFormDialog.hide()
          this.$store.dispatch('toggleSnack', {
            message: 'message.createSuccess',
            type: 'success',
          })

          this.otherLessonTableLoading = true
          setTimeout(() => {
            this.getOtherLessons()
          }, 500)
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
          this.handleAddOtherLesson(false)
        }
      }
    },

    // ============= 新增學生 ============
    handleAddStudentAction() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$refs.addStudentActionDialog.show()
    },

    selectAllAttend() {
      console.log("studentTableData")
      console.log(this.studentTableData)
      // attend_status
      for(let i=0; i<this.studentTableData.length; i++){
        this.studentTableData[i].attend_status = "attend"
      }
    },

    // -- search 學生
    searchStudentOpen(type) {
      this.addStudentFilter.type = type
      this.addStudentFilter.keyword = ''
      this.addStudentFilter.keywordType = this.addStudentSearchTypeOptions[0].value
      this.addStudentSearchTableData = []
      this.addStudentSearchTotal = 0
      this.addStudentSearchTableOptions.tablePage = 1
      this.$refs.addStudentActionDialog.hide()
      this.$refs.addStudentDialog.show('search_student')
      this.searchStudents()
    },
    async searchStudents() {
      this.isSearching = true
      try {
        // ------------- payload --------------
        let payload = {
          controller_name: 'search_student',
          filter_limit: this.addStudentSearchTableOptions.tableLimit,
          filter_page: this.addStudentSearchTableOptions.tablePage - 1,
          filter_item: [{key:"status",value:"active"}],
        }
        if (!this.gDisableStudentCenterFilter) {
          payload['center_id'] = this.staticLessonInfo.school_id
        }
        if (this.$validate.DataValid(this.addStudentFilter.keyword)) {
          const keyword = this.addStudentFilter.keyword.trim()

          if (this.$validate.DataValid(this.addStudentFilter.keywordType)) {
            payload['filter_item'].push({ key: this.addStudentFilter.keywordType, value: keyword })
          } else {
            payload['search'] = keyword
          }
        } else if (!this.gDisableStudentGrade && !this.disableCourseGrade) {
          payload['filter_item'].push({ key: 'grade', value: this.staticLessonInfo.grade })
        }
        // ---------- End of payload ----------

        const { data, total } = await this.$Fetcher.GetStudents(payload)
        this.addStudentSearchTableData = data.map(el => {
          const existed = this.studentTableData.find(elm => elm.id === el.id)
          return {
            id: el.id,
            student_id: el.id,
            student_code: el.student_code,
            grade: el.grade,
            student_name: el.display_student_name,
            phone: el.phone,
            existed: existed ? true : false,
            unpaid: existed ? existed.unpaid : true,
          }
        })
        this.addStudentSearchTotal = total
      } catch (err) {
        this.$common.error(err)
        if (this.addStudentSearchTableOptions.tablePage === 1) {
          this.addStudentSearchTotal = 0
        }
        this.addStudentSearchTableData = []
      } finally {
        this.isSearching = false
      }
    },
    onAddStudentFilterChange() {
      this.addStudentSearchTableOptions.tablePage = 1
      this.addStudentSearchTotal = 0
      this.searchStudents()
    },

    // -- 新增學生(扣除套票)
    async handleAddStudent(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const quota = await this.$Fetcher.GetStudentPackageQuota(parseInt(id))
        this.$store.dispatch('setLoading', false)

        const existed = this.studentTableData.find(elm => elm.id === parseInt(id))
        if (existed) {
          // 如果學生已在課堂，但未比錢，而又有quota，可用quota完成paid
          if (!existed.unpaid) {
            this.$store.dispatch('toggleSnack', {
              message: 'message.alreadyPaid',
              type: 'error',
            })
            return
          }
          if (this.staticLessonInfo.package_used_student_id_list.includes(existed.id)) {
            this.$store.dispatch('toggleSnack', {
              message: 'message.usedPackage',
              type: 'error',
            })
            return
          }
          if (quota < 1) {
            this.$store.dispatch('toggleSnack', {
              message: 'message.noPackageQuotaToPay',
              type: 'error',
            })
            return
          }

          this.paidStudentWithPackage(parseInt(id))
        } else {
          // 如果學生不在課堂，加學生到此課堂，mark unpaid/paid
          this.addStudentToLesson(parseInt(id), quota)
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.$store.dispatch('toggleSnack', {
            message: 'message.noMorePackageQuota',
            type: 'error',
          })
        }

        this.$store.dispatch('setLoading', false)
      }
    },
    // (新增)
    async addStudentToLesson(studentId, quota) {
      this.$store.dispatch('setLoading', true)
      try {
        if (quota > 0) {
          await this.$Fetcher.AddStudentToLessonWithPackage([this.id], studentId)
        } else {
          this.$store.dispatch('setLoading', false)

          const confirm = await this.confirmRef.show({
            title: 'message.confirmAddStudentWithoutPaid',
            message: 'message.confirmAddStudentWithoutPaidMsg',
            confirmBtnText: 'continue',
          })
          if (!confirm) return

          this.$store.dispatch('setLoading', true)
          await this.$Fetcher.AddStudentToLesson(this.id, studentId)
        }

        await this._removeStudentFromExit(studentId)
        this.$store.dispatch('addTimetableUpdateLesson', [this.id])

        this.$refs.addStudentDialog.hide()
        this.$store.dispatch('toggleSnack', {
          message: 'message.createSuccess',
          type: 'success',
        })
        this.getStudentAttendance()
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.createFail',
          message: err,
          isError: true,
        })
        this.$store.dispatch('setLoading', false)
      }
    },
    // (繳付學費)
    async paidStudentWithPackage(studentId) {
      this.$store.dispatch('setLoading', true)
      try {
        await this.$Fetcher.PaidStudentLessonWithPackage(this.id, studentId)
        this.$store.dispatch('addTimetableUpdateLesson', [this.id])
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
        })
        this.$refs.addStudentDialog.hide()
        this.getStudentAttendance()
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
        this.$store.dispatch('setLoading', false)
      }
    },
    _removeStudentFromExit(studentId) {
      return new Promise(async (resolve, reject) => {
        try {
          await this.$Fetcher.RemoveStudentFromDropList(this.id, studentId)
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          reject(err)
        }
      })
    },

    // -- 調堂到此課堂
    async searchStudentLessonOpen(student_id) {
      this.changeLessonStudentId = student_id
      const findStudent = this.addStudentSearchTableData.find(el => el.id === student_id)
      this.addStudentSwitchInfo.student_name = findStudent.student_name

      this.changeLessonFilter.grade = ''
      this.changeLessonFilter.keyword = ''
      this.changeLessonFilter.dateRange = []
      this.changeLessonFilter.date = ''
      this.changeLessonFilter.tutor = ''
      this.searchTableOptions.tablePage = 1
      this.searchTableData = []
      this.searchTableTotal = 0
      this.$refs.addStudentDialog.hide()

      this.isSearching = true
      this.searchTableData = []
      this.$refs.addStudentSwitchDialog.show('search_student_lesson')

      this.searchStudentExistLesson()
    },
    async searchStudentExistLesson() {
      this.isSearching = true
      this.searchTableData = []

      try {
        // --------------- payload ---------------
        const payload = {
          controller_name: 'search_student_lesson',
          filter_limit: this.searchTableOptions.tableLimit,
          filter_page: this.searchTableOptions.tablePage - 1,
          center_id: this.staticLessonInfo.school_id,
          join_tutor_data: true,
          filter_item: [{ key: 'student_not_start', value: this.changeLessonStudentId }],
        }

        if (this.$validate.DataValid(this.changeLessonFilter.tutor) && this.changeLessonFilter.tutor > -1) {
          payload['filter_item'].push({ key: 'staff_id', value: this.changeLessonFilter.tutor })
        }
        if (this.$validate.DataValid(this.changeLessonFilter.grade) && this.changeLessonFilter.grade !== 'all') {
          payload['filter_item'].push({ key: 'grade', value: this.changeLessonFilter.grade })
        }
        if (this.$validate.DataValid(this.changeLessonFilter.date)) {
          payload['filter_item'].push({ key: 'date', value: this.changeLessonFilter.date })
        }

        // For T04: School A lesson can switch to School A/All type lesson. All type lesson only can switch to All type.
        if (this.isAppMode(['T04']) && this.staticLessonInfo.school_type) {
          payload['filter_item'].push({ key: 'school_type', value: this.staticLessonInfo.school_type })
        }

        // ------------ End of payload ------------
        const { data, total } = await this.$Fetcher.GetLessons(payload)
        this.searchTableTotal = total
        this.searchTableData = data.map(el => {
          let canSwitch = false
          const targetAttendance = el.attendance_list.find(elm => elm.student_id === this.changeLessonStudentId)
          if (targetAttendance && targetAttendance.status === 'pending') {
            canSwitch = true
          }
          return {
            id: el.id, // lesson id
            lesson_type: el.lesson_type,
            course_id: el.course_id,
            course_code: el.course_code,
            course_name: el.course_name,
            date: el.date,
            start_time: el.start_time,
            end_time: el.end_time,
            grade: el.grade,
            tutor: el.tutor_data_list.map(t => t.name).join(', '),
            canSwitch: canSwitch,
            is_package_lesson: el.package_used_student_id_list.includes(this.changeLessonStudentId) ? true : false,
          }
        })
      } catch (err) {
        this.$common.error(err)
        if (this.searchTableOptions.tablePage === 1) {
          this.searchTableTotal = 0
        }
        this.searchTableData = []
      } finally {
        this.isSearching = false
      }
    },
    onAddStudentSwitchFilterChange() {
      this.searchTableOptions.tablePage = 1
      this.searchTableTotal = 0
      this.searchStudentExistLesson()
    },
    // (調堂到此課堂)
    async switchStudentToThisLesson(from_lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const fromLesson = this.searchTableData.find(el => el.id === from_lesson_id)
      let confirmObj = {}
      if (
        this.staticLessonInfo.max_student > -1 &&
        this.staticLessonInfo.current_student_num >= this.staticLessonInfo.max_student
      ) {
        // if(this.isAppMode(['T75'])){
        //   this.$store.dispatch('toggleSnack', {
        //     message: 'message.reachedUpperLimit',
        //     type: 'error',
        //   })
        //   return
        // }else{
          confirmObj = {
            enableShowRemindCheckbox: true,
            key: 'exceedStudent',
            title: 'message.confirmToSwitchLesson',
            message: 'message.reachedUpperLimitConfirmSwitch',
          }
        // }
      } else {
        const fromLessonText = `${fromLesson.course_name} ${fromLesson.date} ${fromLesson.start_time} - ${fromLesson.end_time}`
        const toLessonText = `${this.staticLessonInfo.course_name} ${this.staticLessonInfo.date} ${this.staticLessonInfo.start_time} - ${this.staticLessonInfo.end_time}`

        confirmObj = {
          title: 'message.confirmToSwitchLesson',
          message: this.$t('message.confirmSwitchStudentToThisLesson', {
            from_lesson: fromLessonText,
            to_lesson: toLessonText,
            student_name: this.addStudentSwitchInfo.student_name,
          }),
          confirmBtnText: 'continue',
        }
      }
      const confirm = await this.confirmRef.show(confirmObj)
      if (!confirm) return

      this.$store.dispatch('setLoading', true)
      try {
        await this.$Fetcher.SwitchLesson(
          this.changeLessonStudentId,
          from_lesson_id,
          this.id,
          fromLesson.is_package_lesson,
        )
        await this._removeStudentFromExit(this.changeLessonStudentId)
        this.$store.dispatch('addTimetableUpdateLesson', [from_lesson_id, this.id])

        this.$store.dispatch('toggleSnack', {
          message: 'message.switchLessonSuccess',
          type: 'success',
        })
        this.$refs.addStudentSwitchDialog.hide()
        this.getStudentAttendance()
        this.getOtherLessons()
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.switchLessonFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // =========== 導師薪酬計算 ===========
    async handleEditTutorSalary(id, newOpen = true) {
      if (newOpen) {
        if (!this.canEdit || !this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.$refs.tutorFormDialog.setInfo(id)
        for (let key in this.tutorSalaryData) {
          if (key === 'salary_method') {
            this.$set(this.tutorSalaryData, key, 'level')
          } else {
            this.$set(this.tutorSalaryData, key, '')
          }
        }
        this.salaryLevelOptions = []
        await this.$refs.tutorFormDialog.resetForm()
        if (this.$validate.DataValid(id)) {
          const found = this.tutorTableData.find(el => el.id === id)

          this.tutorSalaryData.salary_method = found.salary_method || 'level'
          if (found.salary_method) {
            this.tutorSalaryData.salary_level = found.salary_level
          }
          this.tutorSalaryData.min_salary = found.min_salary
          this.tutorSalaryData.percentage = found.percentage
          this.tutorSalaryData.salary_per_hour = found.salary_per_hour
          this.tutorSalaryData.bonus_rnd = found.bonus_rnd
          this.tutorSalaryData.bonus_performance = found.bonus_performance
          this.tutorSalaryData.bonus_attendance = found.bonus_attendance

          this.$salaryLevelOptions.forEach(item => {
            this.salaryLevelOptions.push({
              value: item.value,
              text: `${item.text} (HK$${
                found?.salary_level_data && found.salary_level_data[item.value]
                  ? found.salary_level_data[item.value]
                  : 0
              })`,
            })
          })
        } else {
          return
        }
      } else {
        this.$refs.tutorFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.tutorFormDialog.show()
      if (confirm) {
        this.$refs.confirmEditTutorSalary.show()
      }
    },
    async tutorSalarySubmit(type = null) {
      const getId = this.$refs.tutorFormDialog.getInfo()
      try {
        // ----------------- payload -----------------
        const list = JSON.parse(JSON.stringify(this.tutorTableData))
        const foundSame = list.findIndex(el => el.id == getId)
        if (foundSame > -1) {
          list[foundSame].salary_level = this.tutorSalaryData.salary_level
          list[foundSame].salary_method = this.tutorSalaryData.salary_method

          list[foundSame].min_salary =
            this.tutorSalaryData.salary_method === 'percentage' && this.tutorSalaryData.min_salary
              ? parseFloat(this.tutorSalaryData.min_salary)
              : 0
          list[foundSame].percentage =
            this.tutorSalaryData.salary_method === 'percentage' && this.tutorSalaryData.percentage
              ? parseFloat(this.tutorSalaryData.percentage)
              : 0
          list[foundSame].salary_per_hour =
            this.tutorSalaryData.salary_method === 'hour' && this.tutorSalaryData.salary_per_hour
              ? parseFloat(this.tutorSalaryData.salary_per_hour)
              : 0

          const bonus_rnd = this.tutorSalaryData.bonus_rnd ? parseFloat(this.tutorSalaryData.bonus_rnd) : 0
          const bonus_performance = this.tutorSalaryData.bonus_performance
            ? parseFloat(this.tutorSalaryData.bonus_performance)
            : 0
          const bonus_attendance = this.tutorSalaryData.bonus_attendance
            ? parseFloat(this.tutorSalaryData.bonus_attendance)
            : 0
          list[foundSame].bonus_rnd = bonus_rnd
          list[foundSame].bonus_performance = bonus_performance
          list[foundSame].bonus_attendance = bonus_attendance
          list[foundSame].total_bonus = bonus_rnd + bonus_performance + bonus_attendance
        }

        let payload = {
          salary_type: [],
          salary_per_hour: [],
          salary_percentage: [],
          multi_salary_level: [],
          salary_bonus: [],
          tutor_id_list: list.map(el => el.id), // 有啲CMS由單一tutor轉做multiple tutor，可能個lesson data會冇 `tutor_id_list`，所以同時save返
        }

        for (let i = 0; i < list.length; i++) {
          payload['salary_type'].push({
            staff_id: list[i].id,
            type: list[i].salary_method,
          })
          if (list[i].salary_method === 'hour') {
            payload['salary_per_hour'].push({
              staff: list[i].id,
              value: list[i].salary_per_hour,
              min: 0,
            })
          } else if (list[i].salary_method === 'percentage') {
            payload['salary_percentage'].push({
              staff: list[i].id,
              value: list[i].percentage,
              min: list[i].min_salary,
            })
          } else if (list[i].salary_method === 'level') {
            payload['multi_salary_level'].push({
              staff_id: list[i].id,
              level: list[i].salary_level,
            })
          }

          payload['salary_bonus'].push({
            staff_id: list[i].id,
            rnd: list[i].bonus_rnd,
            performance: list[i].bonus_performance,
            attendance: list[i].bonus_attendance,
          })
        }
        if (!this.isAppMode(['T21'])) {
          delete payload['salary_bonus']
        }
        // -------------- End of payload --------------

        await this._submitLessonUpdate(type, payload)
        this.$refs.confirmEditTutorSalary.hide()
        this.$refs.tutorFormDialog.hide()
        this.$store.dispatch('toggleSnack', {
          message: 'message.updateSuccess',
          type: 'success',
          refresh: true,
        })
      } catch {
        this.$refs.confirmEditTutorSalary.hide()
        this.handleEditTutorSalary(getId, false)
      }
    },
    onSalaryMethodChanged() {
      this.tutorSalaryData.salary_level = ''
      this.tutorSalaryData.min_salary = ''
      this.tutorSalaryData.percentage = ''
      this.tutorSalaryData.salary_per_hour = ''
      if (this.tutorSalaryData.salary_method === 'hour') {
        const getId = this.$refs.tutorFormDialog.getInfo()
        const found = this.tutorTableData.find(el => el.id == getId)
        if (found) {
          this.tutorSalaryData.salary_per_hour = found.default_salary_per_hour
        }
      }
    },

    // ============= 課堂進度 =============
    // -- (課堂進度 View)
    async openViewProgress(studentId) {
      this.progressTable.page = 1
      this.progressTable.total = 0
      this.progressTable.list = []
      this.progressTable.student_id = studentId
      this.$refs.lessonProgressDialog.show('search_progress')
      this.getProgressData()
    },
    async getProgressData() {
      this.progressTable.loading = true
      try {
        const payload = {
          controller_name: 'search_progress',
          filter_page: this.progressTable.page - 1,
          filter_limit: this.progressTable.limit,
          filter_item: [
            { key: 'student_id', value: this.progressTable.student_id },
            { key: 'lesson_id', value: this.id },
          ],
        }
        const { data, total } = await this.$Fetcher.GetLessonProgresses(payload)
        this.progressTable.total = total
        this.progressTable.list = data.map(item => {
          return {
            ...item,
            create_date: `${item.create_date.substring(0, 10)} ${item.create_date.substring(11, 16)}`,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.progressTable.list = []
        if (this.progressTable.page === 1) {
          this.progressTable.total = 0
        }
      } finally {
        this.progressTable.loading = false
      }
    },
    previewVideo(link) {
      if (!link) return
      this.$store.dispatch('openMediaPopup', { media: link, isVideo: true })
    },

    // -- (新增課堂進度)
    async handleAddProgress(studentId, id = null, newOpen = true) {
      if (newOpen) {
        if (!this.canTutorEdit) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        await this.$refs.progressDialog.resetForm()
        this.progressData.progress = ''
        this.progressData.comment = ''
        this.progressData.video_list = []

        if (this.$validate.DataValid(id)) {
          const found = this.progressTable.list.find(el => el.id === id)
          if (found) {
            this.progressData.progress = found.progress
            this.progressData.comment = found.comment
            if (found.video_id) {
              this.progressData.video_list = [
                {
                  file: null,
                  url: found.video_url || '',
                  name: found.custom_video_title || found.video_title || '',
                  video_id: found.video_id,
                  is_vimeo: true,
                },
              ]
            }
          }
        }
      } else {
        this.$refs.progressDialog.setLoading(false)
      }

      const confirm = await this.$refs.progressDialog.show()
      if (confirm) {
        try {
          let payload = {
            progress: this.progressData.progress,
            comment: this.progressData.comment,
          }
          if (
            this.gEnableLessonProgressVideo &&
            this.$validate.DataValid(this.progressData.video_list, true) &&
            this.progressData.video_list[0].video_id
          ) {
            payload['video_id'] = this.progressData.video_list[0].video_id
          }

          if (this.$validate.DataValid(id)) {
            await this.$Fetcher.UpdateLessonProgress(id, payload)
          } else {
            await this.$Fetcher.NewLessonProgress(studentId, this.id, payload)
          }

          if (this.$validate.DataValid(payload['video_id'])) {
            // remove video id from removedVimeoVideoIDList
            this.$store.dispatch('removeRemovedVimeoVideoID', payload['video_id'])
          }
          await this.removeVimeo()

          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$refs.progressDialog.hide()

          const open = this.$refs.lessonProgressDialog.isOpen()
          if (open) {
            this.progressTable.loading = true
            setTimeout(() => {
              this.progressTable.page = 1
              this.getProgressData()
            }, 500)
          }
        } catch (err) {
          this.showAlert({
            title: 'message.saveSuccess',
            message: err,
            isError: true,
          })
          this.handleAddProgress(studentId, id, false)
        }
      }
    },
    async removeVimeo() {
      const removeList = [...this.$store.getters.removedVimeoVideoIDList]
      return await this.removeUnusedVimeoVideo(removeList)
    },
    // -- (複製影片)
    copyVideo() {
      if (this.$validate.DataValid(this.progressData.video_list, true) && this.progressData.video_list[0].video_id) {
        const data = JSON.stringify(this.progressData.video_list[0])
        this.gfCopyText(data)
      }
    },
    // -- (貼上影片)
    async pasteVideo() {
      const text = await this.gfGetCopiedText()
      if (text) {
        try {
          const data = JSON.parse(text)
          if (
            typeof data === 'object' &&
            this.$validate.DataValid(data.video_id) &&
            this.$validate.DataValid(data.url)
          ) {
            let d = JSON.parse(JSON.stringify(data))
            d.is_vimeo = true
            this.progressData.video_list = [d]
          }
          this.$store.dispatch('toggleSnack', {
            message: 'message.copyVideoPasted',
            type: 'success',
          })
        } catch {}
      }
    },

    // -- (搜尋影片)
    openSearchVideo() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.videoTable.loading = true
      this.videoTable.list = []
      this.videoTable.total = 0
      this.videoTable.page = 1
      this.videoTable.limit = 10
      this.$refs.searchVideoDialog.show('search_video')
      this.searchVideo()
    },
    async searchVideo() {
      this.videoTable.loading = true
      try {
        const getUser = this.gfGetCurrentUserData()
        let payload = {
          controller_name: 'search_video',
          filter_limit: this.videoTable.limit,
          filter_page: this.videoTable.page,
          access_token: getUser.access_token,
          refresh_token: getUser.refresh_token,
        }

        const { data, total } = await this.$Fetcher.GetVimeoVideos(payload)
        this.videoTable.total = total
        this.videoTable.list = data.map(el => {
          return {
            thumbnail: el.pictures && el.pictures.base_link ? el.pictures.base_link : '',
            duration: el.duration || 0,
            videoInput: {
              file: null,
              url: el.video_url,
              name: el.custom_video_title || el.video_title || '',
              video_id: el.video_id,
            },
          }
        })
      } catch (err) {
        this.$common.error(err)
        if (err === 'message.loginExpired') {
          this.$store.dispatch('toggleSnack', { message: err, type: 'error' })
        }
        this.videoTable.list = []
        if (this.videoTable.page === 1) {
          this.videoTable.total = 0
        }
      } finally {
        this.videoTable.loading = false
      }
    },
    // -- (選擇)
    handleSelectVideo(item) {
      if (item.videoInput && item.videoInput.video_id) {
        let d = JSON.parse(JSON.stringify(item.videoInput))
        d.is_vimeo = true
        this.progressData.video_list = [d]
        this.$refs.searchVideoDialog.hide()
      }
    },

    // -- (刪除)
    async handleDeleteProgress(id) {
      if (!this.canTutorEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteLessonProgress(id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
          })
          this.progressTable.page = 1
          this.getProgressData()
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ========== 回復轉堂動作 ===========
    async undoSwitch(studentId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ message: 'message.confirmUndoSwitch' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.UndoSwitch(this.id, studentId)
          this.$store.dispatch('setTimetableCache') // clear cache timetable lessons
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
          this.getOtherLessons()
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
      }
    },

    // ========== 回復跳堂動作 ===========
    async undoSkip(studentId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const found = this.studentTableData.find(el => el.id === studentId)
      const { curr_id, back_id, curr_lesson, back_lesson } = found.undo_skip_payload
      const confirm = await this.confirmRef.show({
        message: this.$t('message.confirmUndoSkip', {
          student_name: found.student_name,
          to_lesson: curr_lesson,
          from_lesson: back_lesson,
        }),
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.UndoSkip(curr_id, back_id, studentId)
          this.$store.dispatch('addTimetableUpdateLesson', [curr_id, back_id])
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getStudentAttendance()
          this.getOtherLessons()
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
      }
    },

    // ============= 請假備註 =============
    // -- (請假備註 View)
    async openLeaveRemark(studentId) {
      this.leaveTable.page = 1
      this.leaveTable.total = 0
      this.leaveTable.list = []
      this.leaveTable.student_id = studentId
      this.$refs.leaveRemarkDialog.show('search_leave_remark')
      this.getLeaveRemarkData()
    },
    async getLeaveRemarkData() {
      this.leaveTable.loading = true
      try {
        const payload = {
          controller_name: 'search_leave_remark',
          filter_page: this.leaveTable.page - 1,
          filter_limit: this.leaveTable.limit,
          filter_item: [
            { key: 'student_id', value: this.leaveTable.student_id },
            { key: 'lesson_id', value: this.id },
          ],
        }
        const { data, total } = await this.$Fetcher.GetLeaveRemarks(payload)
        this.leaveTable.total = total
        this.leaveTable.list = data.map(item => {
          return {
            ...item,
            create_date: `${item.create_date.substring(0, 10)} ${item.create_date.substring(11, 16)}`,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.leaveTable.list = []
        if (this.leaveTable.page === 1) {
          this.leaveTable.total = 0
        }
      } finally {
        this.leaveTable.loading = false
      }
    },
    // -- (新增請假備註)
    async handleAddLeaveRemark(studentId, id = null, newOpen = true) {
      if (newOpen) {
        if (!this.canTutorEdit) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        await this.$refs.addLeaveRemarkDialog.resetForm()
        this.leaveData.comment = ''

        if (this.$validate.DataValid(id)) {
          const found = this.leaveTable.list.find(el => el.id === id)
          if (found) {
            this.leaveData.comment = found.comment
          }
        }
      } else {
        this.$refs.addLeaveRemarkDialog.setLoading(false)
      }

      const confirm = await this.$refs.addLeaveRemarkDialog.show()
      if (confirm) {
        try {
          let payload = {
            comment: this.leaveData.comment,
          }

          if (this.$validate.DataValid(id)) {
            await this.$Fetcher.UpdateLeaveRemark(id, payload)
          } else {
            await this.$Fetcher.NewLeaveRemark(studentId, this.id, payload)
          }

          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$refs.addLeaveRemarkDialog.hide()

          const open = this.$refs.leaveRemarkDialog.isOpen()
          if (open) {
            this.leaveTable.loading = true
            setTimeout(() => {
              this.leaveTable.page = 1
              this.getLeaveRemarkData()
            }, 500)
          }
        } catch (err) {
          this.showAlert({
            title: 'message.saveSuccess',
            message: err,
            isError: true,
          })
          this.handleAddLeaveRemark(studentId, id, false)
        }
      }
    },

    // ============== WhatsApp ==============
    async handleSendPackageLastRemind(studentId, newOpen = true) {
      if (newOpen) {
        this.wtsPhone = null
        this.wstPhoneOptions = []
        this.wtsMsg = ''

        if (this.isAppMode(['T37'])) {
          this.wtsMsg =
            '此信息由DISCOVERY ENGLISH EDUCATION CENTRE 送出\n\n課堂安排尚餘1，為免影響學習進度，請聯絡我們協商課堂安排。'
        }

        const found = this.studentTableData.find(el => el.id === studentId)
        if (!found) return

        for (let i = 0; i < found.whatsapp_data.length; i++) {
          this.wstPhoneOptions.push({
            value: i,
            data: found.whatsapp_data[i].phone,
            text: `${found.whatsapp_data[i].name} ${found.whatsapp_data[i].phone}`,
          })
        }
        if (this.wstPhoneOptions.length) {
          this.wtsPhone = this.wstPhoneOptions[0].value
        }
      } else {
        this.$refs.selectWtsDialog.setLoading(false)
      }

      const confirm = await this.$refs.selectWtsDialog.show()
      if (confirm) {
        if (!this.$validate.DataValid(this.wtsPhone)) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.noWtsPhone',
            type: 'error',
          })
          this.handleSendPackageLastRemind(studentId, false)
          return
        }
        const foundPhone = this.wstPhoneOptions.find(el => el.value === this.wtsPhone)
        window.open(
          `https://api.whatsapp.com/send?phone=852${foundPhone.data}&text=${this.wtsMsg.replace(
            /(?:\r\n|\r|\n)/g,
            '%0A',
          )}`,
          '_blank',
        )
        this.$refs.selectWtsDialog.hide()
      }
    },

    // ============= 學員回饋 =============
    openFeedback(feedback) {
      this.showAlert({
        title: 'studentFeedback',
        message: feedback || 'noComment',
        isError: false,
      })
    },

    // ============== Log Record =============
    async getLogData() {
      if (this.canViewLog && this.$refs.logTableRef) {
        this.logLoading = true
        const filter = this.$refs.logTableRef.getFilter()
        try {
          const payload = {
            page: filter.page - 1,
            limit: filter.limit,
          }
          const { data, total } = await this.$Fetcher.GetLessonLogs(this.id, payload)
          this.logTableData = data
          this.logTableTotal = total
        } catch (err) {
          this.$common.error(err)
          this.logTableData = []
          if (filter.page === 1) {
            this.logTableTotal = 0
          }
        } finally {
          this.logLoading = false
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: ClassDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      let next = await this.getLessonById()
      if (next) await this.getLogData()
    },
  },

  created() {
    const list = []
    for (let i = 1; i <= 30; i++) {
      list.push({
        value: i,
        text: this.$t('person', { count: i }),
      })
    }
    if (!this.isAppMode(['T01'])) {
      list.unshift({ value: -1, text: this.$t('noLimit') })
    }
    this.maxStudentOptions = list
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    this.tableLoading = true
    this.otherLessonTableLoading = true
    this.tutorTableLoading = true
    this.logLoading = true
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  async beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      // remove unused vimeo before leave
      await this.removeVimeo()
      this.$XHR.abort()
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
.course-info {
  & .v-card__title {
    background-color: #ffffff !important;
    color: var(--v-colorBlack-base) !important;
    font-size: 0.875rem;
    font-weight: 500;
  }

  & .course-code {
    background-color: var(--v-primary-base);
    color: var(--v-colorWhite-base) !important;
    font-size: 0.875rem;
    font-weight: 500;
    min-height: 53px;
  }
}

::v-deep .v-date-picker-table {
  & > table > thead > tr {
    & > th {
      color: #000000;
      font-weight: 400 !important;
      font-size: 0.75rem !important;
    }
    & > th:nth-child(1) {
      color: #ff0808 !important;
    }
  }

  &.v-date-picker-table--date > table > tbody > tr > td {
    & > button {
      border-radius: 6px !important;
      font-weight: 400 !important;
      color: #272727 !important;
    }
    & > button.v-btn--disabled {
      color: #272727 !important;
    }
    & > button:not(.v-btn--disabled) {
      background: #e3f0ff !important;
    }
    & > button.v-date-picker-table__current {
      color: #ffffff !important;
      background: #1664c1 !important;
      border-color: #1664c1 !important;
    }
  }
}
::v-deep .v-date-picker-header {
  & .v-date-picker-header__value button {
    color: #000000 !important;
    font-size: 1.125rem !important;
    font-weight: 500 !important;
  }
}

.color-brick-row {
  display: flex;
  align-items: center;
  line-height: 1;

  & > .color-brick {
    width: 25px;
    padding: 25px 0 0 0;
    border-radius: 6px;
  }
}

.timetableMode-view {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;

  &::before {
    content: '';
    background-color: #000000;
    opacity: 0.65;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 2;
  }

  & > .btn-timetableMode-open {
    position: absolute;
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 3;
  }
}
</style>
